export const ns1 = {
  sidebar: {
    toggle: 'Toggle sidebar',
    mobileDescription: 'Displays the mobile sidebar.',
    title: 'Sidebar',
  },
  breadcrumb: {
    more: 'More',
    navigationLabel: 'breadcrumb',
  },
  timeInput: {
    secondsPlaceholder: 'ss',
    seconds: 'Seconds',
    minutesPlaceholder: 'mm',
    minutes: 'Minutes',
    hoursPlaceholder: 'hh',
    hours: 'Hours',
  },
  richTextEditor: {
    link: {
      enterUrl: 'Enter URL',
    },
    file: {
      remove: 'Remove file',
      untitled: 'Untitled file',
    },
    toolbar: {
      horizontalRule: 'Horizontal rule',
      addLink: 'Add link',
      codeBlock: 'Code block',
      inlineCode: 'Inline code',
      blockquote: 'Blockquote',
      heading: 'Heading',
      taskList: 'Task list',
      underline: 'Underline',
      strikethrough: 'Strikethrough',
      orderedList: 'Ordered list',
      bulletList: 'Bullet list',
      italic: 'Italic',
      bold: 'Bold',
    },
  },
  codeStepProperties: {
    tabs: {
      automation: 'Code automation',
      details: 'Code details',
    },
  },
  executionPresetVersioning: {
    historyButtonLabel: 'Preset history',
    title: 'Version history',
    description: 'A version is saved automatically each time you simulate.',
    empty: 'No versions yet',
    loading: 'Loading versions…',
    loadError: "Couldn't load version history. Please try again.",
    current: 'Current',
    previousVersions: 'Previous versions',
    versionLabel: 'Version {{number}}',
    by: 'by {{author}}',
    createRevision: 'Create new version',
    creatingRevision: 'Creating…',
    productionLocked:
      'This preset is locked because a version is in Production. Create or restore a new version to make changes.',
  },
  common: {
    clearSearch: 'Clear search',
    openSearch: 'Open search',
    speedProfileInfo: {
      label: 'Speed profile information',
      fast: 'Fast: 1x full speed',
      standard: 'Standard: 0.75x full speed',
      slow: 'Slow: 0.5x full speed',
      gentle: 'Gentle: 0.25x full speed',
    },
    noItemsFound: 'No {{dataLabel}} found.',
    process: 'process',
    copyToClipboard: 'Copy to clipboard',
    copied: 'Copied!',
    copy: 'Copy',
    home: 'Home',
    studio: 'Studio',
    devices: 'Devices',
    workflows: 'Workflows',
    library: 'Library',
    workflow: 'Workflow',
    create: 'Create',
    creating: 'Creating...',
    'control-room': 'Control Room',
    assetLibrary: 'Asset Library',
    lens: 'Lens',
    userManagement: 'User management',
    secrets: 'Secrets',
    labSettings: 'Lab settings',
    settingsMenu: 'Settings',
    add: 'Add',
    update: 'Update',
    delete: 'Delete',
    duplicate: 'Duplicate',
    cancel: 'Cancel',
    abort: 'Abort',
    close: 'Close',
    imageLightbox: {
      viewFullSize: 'View full size',
      title: 'Image preview',
    },
    comingSoon: 'Coming soon',
    createdBy: 'Created by',
    status: 'Status',
    select: 'Select',
    selectPlaceholder: 'Select {{label}}',
    loading: 'Loading...',
    loadingResource: 'Loading {{resource}}...',
    error: 'Error',
    yes: 'Yes',
    no: 'No',
    pause: 'Pause',
    labware: 'Labware',
    tasks: 'Tasks',
    task: 'Task',
    steps: 'Steps',
    logic: 'Logic',
    notApplicable: 'N/A',
    configuration: 'Configuration',
    softwareVersion: 'Software version',
    definition: 'Definition',
    unknown: 'Unknown',
    minDuration: 'Min duration',
    maxDuration: 'Max duration',
    save: 'Save',
    saveWorkflow: 'Save workflow',
    saveProcess: 'Save process',
    properties: 'Properties',
    slot: 'Slot',
    instrument: 'Instrument',
    true: 'True',
    false: 'False',
    deleteResource: 'Delete {{resource}}',
    noResults: 'No results',
    name: 'Name',
    type: 'Type',
    data: 'Data',
    inputs: 'Inputs',
    outputs: 'Outputs',
    lock: 'Lock',
    unlock: 'Unlock',
    expand: 'Expand',
    collapse: 'Collapse',
    help: 'Help',
    conditional: 'Conditional',
    if: 'If',
    elseIf: 'ElseIf',
    else: 'Else',
    apply: 'Apply',
    search: 'Search..',
    tasksRunning: 'tasks running',
    progress: 'Progress',
    active: 'Active',
    queued: 'Queued',
    finished: 'Finished',
    aborted: 'Aborted',
    unresolved: 'Unresolved',
    dateTime: {
      dateAtTime: '{{date}} at {{time}}',
      nextHourAt: 'Next hour, {{time}}',
      todayAt: 'Today, {{time}}',
      tomorrowAt: 'Tomorrow, {{time}}',
      yesterdayAt: 'Yesterday, {{time}}',
      secondsAgo: '{{count}}s ago',
      minutesAgo: '{{count}}m ago',
    },
    countdown: {
      expired: 'Expired',
    },
    production: 'Production',
    test: 'Test',
    to: 'to',
    durationToGo: '{{duration}} to go',
    tasksRunning_one: '{{count}} task running',
    tasksRunning_other: '{{count}} tasks running',
    confirm: 'Confirm',
    edit: 'Edit',
    dragToReorder: 'Drag to reorder',
    actionsMenu: 'Actions menu',
    instruments: 'Instruments',
    selectInstruments: 'Select instruments',
    instrumentTypeMismatch:
      'Only instruments of the same type and version can be selected together',
    unsavedChangesWarning:
      'You have unsaved changes. Are you sure you want to leave?',
  },
  accordion: {
    expandAll: 'Expand all',
  },
  // Shared MachineFileBrowser (device panel + asset library) — owns its own
  // neutral copy rather than borrowing a feature namespace.
  machineFileBrowser: {
    up: 'Up one level',
    browseError: 'Could not list the directory',
    uploading: 'Uploading',
    uploaded: 'Uploaded',
    uploadFailed: 'Upload failed',
    imported: 'Method imported',
    importFailed: 'Failed to import method',
    inPackage: 'In package',
    inPackageHint:
      'Already in this package — re-importing creates a new version',
  },
  rolesMultiSelect: {
    placeholder: 'Select roles',
    loadError: 'Failed to load roles',
  },
  assetLibrary: {
    packageLabel: 'Package',
    packagesHeading: 'Packages',
    appsHeading: 'Apps',
    standaloneAssetsHeading: 'Standalone assets',
    assetsInsideHeading: 'Assets inside',
    breadcrumbRoot: 'Assets',
    versionedWithApp: 'Versioned with app',
    selectAsset: 'Select {{name}}',
    cardMeta: {
      editedAssets_one: '{{time}} · {{count}} asset',
      editedAssets_other: '{{time}} · {{count}} assets',
      editedUsage: '{{time}} · {{usage}}',
    },
    notUsed: 'Not used',
    usedInAutomations: 'Used in {{count}} automations',
    panel: {
      editor: 'Editor',
      versions: 'Versions',
      usage: 'Usage',
      saveAsNewVersion: 'Save as new version',
      currentVersion: 'Current version',
      lastModified: 'Last modified',
      unknownUser: '—',
      filepath: 'File path',
      windowsDevice: 'Windows agent',
      checksum: 'Checksum (SHA-256)',
      refetch: 'Refetch',
      refetchedNewVersion: 'Refetched — new version v{{version}} created',
      refetchedNoChange: 'Refetched — already up to date, no changes',
      noSource: 'No preview available for this asset type.',
      noUsage: 'Not used in any automations yet.',
      expand: 'Expand editor',
      versionedWithAppDescription:
        "This asset doesn't have independent versions. It's versioned as part of the app it belongs to.",
      currentAppVersion: 'Current app version',
    },
    noPackages: 'No packages yet',
    noAssets: 'No assets created yet.',
    createAsset: 'Create asset',
    createPackage: 'Create package',
    newAssetTitle: 'New asset',
    newAssetDescription: 'Choose a type to get started.',
    newPackageTitle: 'New package',
    fields: {
      code: 'Code',
    },
    method: {
      upload: 'Upload a file',
      pullFromMachine: 'Pull from a machine',
      file: 'Method file',
      machine: 'Windows machine',
      selectMachineHint: 'Select a Windows machine to browse its files.',
      noMachines: 'No Windows machines available.',
      machinesError: 'Could not load machines. Please try again.',
      importToLibrary: 'Import to library',
      uploadFailed: 'Could not upload the method. Please try again.',
    },
    types: {
      app: 'App',
      method: 'Method',
      binary: 'Binary',
      notebook: 'Notebook',
    },
    typeDescriptions: {
      function: 'Python scripts executed during workflow runs',
      method: 'Instrument method files for device control',
      data: 'CSV data files referenced as run parameters',
      binary: 'Any other file type. Properties only, no editor.',
      app: 'A versioned bundle of assets referenced as a unit in Canvas',
      notebook: 'A Jupyter notebook for analysing execution data',
    },
  },
  navbar: {
    aria: {
      toggleSidebar: 'Toggle sidebar - notifications icon',
      mainNavigationButton: 'Main navigation button',
      mainNavigation: 'Main navigation',
    },
    sideRail: 'Side rail',
  },
  auth: {
    signOut: 'Sign out',
    loadingProfile: 'Loading user profile',
    openProfileMenu: 'Open profile menu for {{name}}',
    openUserMenu: 'Open user menu',
    updatePin: 'Update your PIN',
  },
  preferences: {
    title: 'Preferences',
    saveError: 'Could not save your preferences. Please try again.',
    language: {
      sectionTitle: 'Language',
      label: 'Language preference',
      description: 'Choose the language you want to use',
      names: {
        en: 'English',
        de: 'Deutsch',
      },
    },
  },
  automation: {
    select: 'Select automation',
    selectCurrent: 'Select automation, current: {{name}}',
    new: 'New automation',
    card: {
      deleteDialog: {
        description: 'Are you sure you want to delete this automation?',
        title: 'Delete automation',
      },
      latestVersion: 'Using latest version',
      updateAvailable: 'Update available',
      hasWarnings: 'Has warnings',
      aria: {
        selectAutomation: 'Select automation {{name}}',
        openMenu: 'Open menu for {{name}}',
        statusLoading: 'Checking automation status',
      },
    },
    createDialog: {
      noGroupsFound: 'No groups found',
      instrumentGroupsLoadError: 'Failed to load instrument groups',
      title: 'Create automation',
      description:
        'Name your automation and select an instrument group to run your workflow.',
      nameLabel: 'Automation name',
      namePlaceholder: 'Enter automation name',
      instrumentsGroupLabel: 'Instrument group',
      selected: 'Selected:',
      noGroupSelected: 'No group selected',
      selectGroup: 'Select instrument group {{name}}',
      instrumentGroupFetchError: 'Failed to load instrument group data',
    },
    automap: {
      title: 'Automation created successfully',
      autoMappedTitle_one: '{{count}} task automatically mapped',
      autoMappedTitle_other: '{{count}} tasks automatically mapped',
      autoMappedDescription:
        'Each task had only one compatible instrument available.',
      manualRequiredTitle_one: '{{count}} task requires manual mapping',
      manualRequiredTitle_other: '{{count}} tasks require manual mapping',
      manualRequiredDescription:
        "Multiple compatible instruments are available for these tasks. You'll need to select which instrument to use.",
      unmappableTitle_one: '{{count}} task cannot be mapped',
      unmappableTitle_other: '{{count}} tasks cannot be mapped',
      unmappableDescription:
        'No compatible instruments are available for these tasks in {{instrumentGroupName}}.',
      viewDetails: 'View details',
      done: 'Done',
      illDoItLater: "I'll do it later",
      guideMe: 'Guide me through',
    },
  },
  status: {
    aborting: 'Aborting...',
    canceled: 'Canceled',
    cleanup: 'Cleanup',
    committed: 'Committed',
    completed: 'Completed',
    constraintBroken: 'Constraint broken',
    created: 'Created',
    failed: 'Failed',
    failedToCommit: 'Failed to commit',
    failedToPlan: 'Failed to plan',
    idle: 'Idle',
    inProgress: 'In progress',
    lowInventory: 'Low inventory',
    new: 'New',
    notStarted: 'Not started',
    pending: 'Pending...',
    planned: 'Planned',
    planning: 'Planning...',
    planningReady: 'Planning ready',
    processDependent: 'Process dependent',
    processParallel: 'Process parallel',
    ready: 'Ready',
    readyToRun: 'Ready to run',
    acknowledged: 'Acknowledged',
    resolved: 'Resolved',
    resuming: 'Resuming...',
    scheduled: 'Scheduled',
    setup: 'Setup',
    skipped: 'Skipped',
    unspecified: 'Unspecified',
    actionOverdue: 'Action overdue',
    actionSkipped: 'Action skipped',
    actionComplete: 'Action complete',
    studioBlocked: 'Blocked',
    studioConfigured: 'Configured',
    studioEnabled: 'Enabled',
    studioInitialized: 'Initialized',
    studioNeedsTraining: 'Needs training',
    studioNotConfigured: 'Not configured',
    studioOffline: 'Offline',
    studioOnline: 'Online',
    studioTrained: 'Trained',
    studioWaiting: 'Waiting...',
    dueNow: 'Due now',
    upcoming: 'Upcoming',
    calculating: 'Calculating...',
    reviewPlan: 'Review plan',
    preparing: 'Preparing',
    settingUp: 'Setting up',
    awaitingStart: 'Awaiting start',
    awaitingCleanup: 'Awaiting cleanup',
    cleaningUp: 'Cleaning up',
    pausing: 'Pausing...',
    removed: 'Removed',
    actionRequired: 'Action required',
    paused: 'Paused',
    eStopped: 'E-Stop',
    fStopped: 'F-Stop',
    warning: 'Warning',
    safetyEvent: 'Safety event',
  },
  calendar: {
    scheduleCard: {
      ariaLabel: 'Schedule card',
      titledAriaLabel: 'Schedule: {{title}}',
    },
    previousDay: 'Previous day',
    nextDay: 'Next day',
  },
  toast: {
    error: {
      failedToAddNodeToCanvas:
        'Failed to add node to the Canvas, please contact the Automata team',
      someDevicesFailedToRegister:
        'Some devices failed to register. {{registered}} of {{total}} devices were registered successfully.',
      failedToAddDevicesToGroup:
        'Devices were registered but could not be added to the group.',
      failedToDeleteDevices:
        'Failed to delete one or more devices. Please try again.',
    },
    info: {
      automationMismatchOnPaste:
        'Automation configuration was not copied - configure devices for the pasted nodes.',
      pasteAutomapAllMapped_one:
        'Auto-mapped {{count}} task to a compatible instrument.',
      pasteAutomapAllMapped_other:
        'Auto-mapped {{count}} tasks to compatible instruments.',
      pasteAutomapPartial_one:
        'Auto-mapped {{count}} task. {{remaining}} need manual configuration.',
      pasteAutomapPartial_other:
        'Auto-mapped {{count}} tasks. {{remaining}} need manual configuration.',
    },
  },
  errorFallback: {
    title: 'Something went wrong',
  },
  forbidden: {
    title: 'Access denied',
    description: 'You do not have permission to view this page.',
    backToHome: 'Back to home',
  },
  workflowLibrary: {
    resourceName: 'library',
    libraryRow: {
      rowActions: 'Row actions',
    },
    tempSimulatedErrorSelect: {
      placeholder: 'Select preset workflow (optional)',
      searchPlaceholder: 'Search workflow',
      empty: 'No workflow found',
    },
    createNew: 'Create new',
    createNewWorkflow: 'Create new workflow',
    createWorkflow: 'Create workflow',
    createNewProcess: 'Create new process',
    createProcess: 'Create process',
    process: 'Process',
    processes: 'Processes',
    searchBar: {
      placeholder: 'Search by name or filter by tag...',
      openLabel: 'Open search',
      filterLabel: 'Filter by tag',
    },
    selectWorkcell: 'Select workcell...',
    searchWorkcell: 'Search workcell...',
    noWorkcellFound: 'No workcell found',
    workflowCreationError: 'Error creating workflow',
    errorLoadingLibrary: 'Error loading library',
    presetWorkflowIncompatible:
      'Preset workflow is not compatible with this workcell. Some required instruments are missing.',
    duplicateAutomationDialog: {
      title: 'Duplicate automation',
      description: 'Enter a name for the duplicated automation',
      placeholder: 'e.g., Hamilton STAR automation',
      copySuffix: '{{name}} (copy)',
    },
    deleteWorkflowDialog: {
      title: 'Delete workflow',
      description:
        'Are you sure you want to delete "{{workflowName}}"? This action cannot be undone.',
      gxpDescription: 'Delete workflow: {{workflowName}}',
    },
    deleteWorkflowError: 'Failed to delete workflow',
    duplicateWorkflowDialog: {
      title: 'Duplicate workflow',
      definitionOnlyDescription:
        'Duplicate only the workflow definition without automations',
      definitionAndAutomationsDescription:
        'Duplicate workflow definition and selected automations',
      executionPresets_one: '{{count}} execution preset',
      executionPresets_other: '{{count}} execution presets',
    },
    duplicateWorkflowError: 'Failed to duplicate workflow',
    duplicateWorkflowSuccess: 'Workflow duplicated successfully',
    renameWorkflowDialog: {
      title: 'Rename workflow',
      description: 'Enter a new name for "{{name}}"',
      nameLabel: 'Workflow name',
    },
    renameWorkflowError: 'Failed to rename workflow',
    renameWorkflowSuccess: 'Workflow renamed successfully',
    archiveWorkflowDialog: {
      title: 'Archive workflow {{workflowName}}',
      description:
        'You are about to archive {{workflowName}} from the library.',
      warning:
        'All automations and associated execution presets in this workflow will be archived.\nArchived items will no longer be available for new executions.\n\nExisting execution records remain preserved for traceability in the execution log.',
      reasonLabel: 'Reason for archiving',
      reasonPlaceholder:
        'Add a reason for this action. This will be recorded in the user log.',
      confirm: 'Archive workflow',
    },
    tags: {
      label: 'Tag',
      listLabel: 'Tags',
      editorLabel: 'Edit tags',
      addLabel: 'Add tag',
      removeLabel: 'Remove tag {{name}}',
      moreLabel_one: '+{{count}} more tag',
      moreLabel_other: '+{{count}} more tags',
      searchPlaceholder: 'Search or create',
      createPrefix: 'Create',
      noResults: 'No tags found',
      manageLabel: 'Manage tag {{name}}',
      renameInputLabel: 'Tag name',
      deleteDisabledTooltip: 'Detach this tag from all items before deleting',
      renameSuccess: 'Tag renamed',
      renameError: 'Failed to rename tag',
      deleteSuccess: 'Tag deleted',
      deleteError: 'Failed to delete tag',
      validation: {
        empty: 'Tag name must not be empty',
        maxLength: 'Tag name must be {{maxLength}} characters or fewer',
        invalidCharacters:
          'Tag name may only contain letters, digits, full stops, and single spaces',
      },
    },
    archiveWorkflowSuccess: 'Workflow archived successfully',
    archiveWorkflowError: 'Failed to archive workflow',
    deleteProcessDialog: {
      title: 'Delete process',
      description:
        'Are you sure you want to delete "{{processName}}"? This action cannot be undone.',
      gxpDescription: 'Delete process: {{processName}}',
    },
    deleteProcessError: 'Failed to delete process',
    duplicateProcessDialog: {
      title: 'Duplicate process',
      description: 'Create a copy of "{{name}}"',
      nameLabel: 'Process name',
      copySuffix: '{{name}} (Copy)',
      selectAutomationsLabel: 'Select automations to duplicate',
      definitionOnly: 'Definition only',
      definitionOnlyDescription:
        'Duplicate only the process definition without automations',
      definitionAndAutomations: 'Definition + automations',
      definitionAndAutomationsDescription:
        'Duplicate process definition and selected automations',
      warning:
        'Execution presets and associated production and test stage tags will not be duplicated. The copy will start with a new version history.',
    },
    duplicateProcessError: 'Failed to duplicate process',
    duplicateProcessSuccess: 'Process duplicated successfully',
    rightPanel: {
      automations: 'Automations',
      executionPresetsTest: 'Execution presets: Test [{{count}}]',
      executionPresetsProduction: 'Execution presets: Production [{{count}}]',
      executionPresets: 'Execution presets [{{count}}]',
      noAutomations: 'No automations',
      executionPresetsUnavailable:
        'Execution preset details are not yet available for processes.',
      close: 'Close panel',
    },
    permissions: {
      writeDefinition:
        "You don't have permission to edit definitions. Ask your administrator to grant write:definition access.",
      createSimulationTest:
        "You don't have permission to run test simulations. Ask your administrator to grant create:simulation:test access.",
      createSimulationProduction:
        "You don't have permission to run production simulations. Ask your administrator to grant create:simulation:production access.",
    },
  },
  job: {
    estTime: 'Est time',
    sidebar: {
      toggleSidebar: 'Toggle sidebar',
    },
  },
  canvasNodeProperties: {
    header: {
      closeAriaLabel: 'Close properties panel',
    },
    analyse: {
      // Displayed node-type name (node library entry, default node name
      // seed). Kept separate from the `analyse` node type/key names, which
      // stay internal identifiers.
      title: 'Intelligence',
      promptLabel: 'Prompt',
      promptPlaceholder: 'Describe what you want Eva to analyse…',
      agenticLabel: 'Agentic',
      agenticDescription:
        'When on, Eva can explore freely to reach an outcome. When off, the notebook is run exactly as written.',
      credentialLabel: 'Token',
    },
    tabs: {
      taskAutomation: 'Task automation',
      taskDetails: 'Task details',
      labwareAutomation: 'Labware automation',
      labwareDetails: 'Labware details',
      details: 'Details',
      automation: 'Automation',
    },
    labwareAutomation: {
      startingLocationLabel: 'Starting location',
    },
    colorPicker: {
      changeColourAriaLabel: 'Change colour',
    },
    errors: {
      nameAlreadyExists: 'Name already exists',
      nameMinLength: 'Name must be at least {{minimum}} characters long',
      nameMaxLength: 'Name must be at most {{maximum}} characters long',
    },
    connectedData: {
      title: 'Connected data',
      dataOutputs: 'Data outputs',
      dataInputs: 'Data inputs',
      noDataOutputs: 'No data outputs',
      noDataInputs: 'No data connections into this step',
      fromStep: 'From {{step}}',
    },
    dataConnections: {
      pythonFileUploadInput: 'Python file upload input',
      pythonCode: 'Python code',
      uploadCode: 'Upload code',
      updating: 'Updating...',
      nodeMatchesCode: 'Node matches code',
      changesDetected: 'CHANGES DETECTED: Node and code are out of sync',
      introspectionError: 'Introspection error',
      fileUploadError: 'File upload error',
      failedToReadFile: 'Failed to read file',
      fileTooLarge: 'File size must be less than 500KB',
      invalidFileType: 'Please upload a Python (.py) file',
      assetReference: {
        referenceAsset: 'Reference asset',
        writeCustomCode: 'Write custom code instead',
        searchPlaceholder: 'Search assets...',
        showAssets: 'Show assets',
        clearSelection: 'Clear selection',
        noResults: 'No assets found',
        version: 'Version',
        latestVersion: 'Latest (v{{revision}})',
        specificVersion: 'Specific version',
        changeVersion: 'Change version',
        latest: 'latest',
        fromPackage: 'from {{package}}',
        readOnly: 'Read only',
        newerAvailable: 'A newer version (v{{revision}}) is available',
        updateToRevision: 'Update to v{{revision}}',
        unlink: 'Unlink',
        brokenReference:
          'This referenced function could not be loaded. It may have been deleted.',
        signatureUnavailable:
          'Could not derive the function signature from this version. Node inputs and outputs were cleared.',
        loading: 'Loading function...',
        subtitle: 'Asset reference',
      },
    },
    valueType: {
      customValue: 'Custom value',
      variableValue: 'Variable value',
      inputDataValue: 'Input data value',
      searchInputs: 'Search inputs',
      selectInput: 'Select input type',
      noCompatibleInputs: 'No compatible inputs',
      noCompatibleVariables: 'No compatible variables',
      addNewVariable: 'Add new variable',
      executionPresetValue: 'Execution preset value',
      secretValue: 'Secret value',
      assetValue: 'From asset library',
    },
    assetPicker: {
      searchPlaceholder: 'Search file assets...',
      noResults: 'No file assets found',
    },
  },
  labware: {
    unknownName: 'Unknown labware',
    types: {
      Plate: 'Plate',
      Reservoir: 'Reservoir',
      'Tube Rack': 'Tube Rack',
      'Tip Rack': 'Tip Rack',
    },
    add: 'Add labware',
    outputSlot: 'Output slot',
    reusableAcrossBatches: 'Reusable across batches',
    repeatsOnEveryBatch: 'Repeats on every batch',
    simulationError: 'Involved in a simulation error',
    totalUnits: 'Total units',
    labwareType: 'Labware type',
    motionProfile: {
      title: 'Labware motion profile',
      cardTitle: 'Motion profile',
      add: 'Add motion profile',
      remove: 'Remove motion profile',
      speed: 'Speed',
      speedFast: 'Fast',
      speedStandard: 'Standard',
      speedSlow: 'Slow',
      speedGentle: 'Gentle',
    },
    addNewLabware: 'Add new labware',
    editLabware: 'Edit labware',
    viewLabware: 'View labware',
    editDialog: {
      description: 'Edit this labware definition.',
      error: 'Failed to update labware. Please try again.',
    },
    viewDialog: {
      description: 'View this labware definition.',
    },
    errorHandling: {
      returnLocation: 'Return location',
      returnLocationOptions: {
        start_location: 'Start location',
        outside_workflow: 'Outside workflow (manual)',
        waste_bin: 'Waste bin',
      },
    },
    createDialog: {
      description: 'Define a new labware type.',
      info: 'The new labware will be selected for {{labwareName}} and also be available for use in other workflows',
      category: {
        tipRack: 'Tip rack',
        tubeRack: 'Tube rack',
      },
      namePlaceholder: 'Enter labware name',
      vendor: 'Vendor',
      vendorPlaceholder: 'Enter vendor name',
      partNumber: 'Part number',
      partNumberPlaceholder: 'Enter part number (optional)',
      count: 'Count',
      wellsPlaceholder: 'Wells #',
      rows: 'Rows',
      rowsPlaceholder: 'Rows #',
      cols: 'Cols',
      colsPlaceholder: 'Column #',
      wellBottom: 'Well bottom',
      none: 'None',
      wellBottomType: {
        flat: 'Flat',
        round: 'Round',
        v: 'V',
      },
      dimensions: 'Dimensions (mm)',
      length: 'Length',
      width: 'Width',
      height: 'Height',
      transportGrip: 'Transport grip (mm)',
      autoCalculateGrip: 'Auto-calculate transport grip',
      zOffset: 'Z-offset',
      zOffsetPlaceholder: 'Z-axis offset',
      cgLandscape: 'CG landscape',
      cgPortrait: 'CG portrait',
      closedGripperPlaceholder: 'Closed gripper',
      error: 'Failed to create labware. Please try again.',
      validation: {
        nameRequired: 'Name is required',
        nameMaxLength: 'Name must be 100 characters or less',
        nameAlphanumeric:
          'Name must contain at least one alphanumeric character',
        vendorRequired: 'Vendor is required',
        vendorMaxLength: 'Vendor must be 25 characters or less',
        lengthPositive: 'Length must be positive',
        widthPositive: 'Width must be positive',
        heightPositive: 'Height must be positive',
        numberInvalid: 'Must be a valid number',
        integerRequired: 'Must be a whole number',
        positiveRequired: 'Must be a positive number',
      },
    },
  },
  robotTraining: {
    select: 'Select...',
    begin: 'Connect to a robot to begin teaching',
    start: 'Start teaching',
    inactivityTimeout: 'Disconnected from robot — no activity for 10 minutes',
    needToConnect:
      'Connect instruments to this robot in <studioLink>Studio</studioLink> to begin teaching',
    robotDetails: {
      title: 'Robot teach details',
      label: 'Select robot',
      connect: 'Connect',
      disconnect: 'Disconnect',
      homeRobot: 'Home gripper',
      openGripper: 'Open gripper',
      closeGripper: 'Close gripper',
      jogAngle: 'Jog angle [°]',
      jogIncrement: 'Jog increment [°]',
      status: {
        lockedByRuntime:
          'Device is used in a workflow, wait for workflow to finish to train',
        lockedByStudio:
          'Device is connected in Studio, disconnect from Studio to train',
      },
      connectionSettingsRequired:
        'Please configure IP address and port to connect',
      noConnectionSettings: 'No connection settings available for this device.',
      noModuleError: 'No module found for robot',
      homePosition: 'Home position [mm]',
      homePositionDescription:
        'Apply the current live coordinates to the home position.',
      cartesianControls: 'Cartesian',
      jointControls: 'Joints',
      decreaseJoint: 'Decrease J{{joint}} angle',
      decreaseJointTooltip: 'J{{joint}} -',
      increaseJoint: 'Increase J{{joint}} angle',
      increaseJointTooltip: 'J{{joint}} +',
      axisLabels: {
        xy: 'XY',
        z: 'Z',
        rail: 'RAIL',
        rotation: 'ROT',
      },
      moveYForward: 'Move Y forward',
      moveYBackward: 'Move Y backward',
      moveXLeft: 'Move X left',
      moveXRight: 'Move X right',
      moveZUp: 'Move Z up',
      moveZDown: 'Move Z down',
      moveRailBackward: 'Move rail backward',
      moveRailForward: 'Move rail forward',
      rotateCounterClockwise: 'Rotate counter-clockwise',
      rotateClockwise: 'Rotate clockwise',
      moveYForwardTooltip: 'Y +',
      moveYBackwardTooltip: 'Y -',
      moveXLeftTooltip: 'X -',
      moveXRightTooltip: 'X +',
      moveZUpTooltip: 'Z +',
      moveZDownTooltip: 'Z -',
      moveRailBackwardTooltip: 'Rail -',
      moveRailForwardTooltip: 'Rail +',
      rotateCounterClockwiseTooltip: 'Rotate +',
      rotateClockwiseTooltip: 'Rotate -',
      freeMode: 'Free mode',
      jogMode: 'Jog',
    },
    coordinates: {
      title: 'Live coordinates',
      cartesian: 'Cartesian coordinates [mm]',
      joints: 'Joint coordinates [°]',
      joint: 'J{{index}}',
      noJointData: 'No joint data available',
      x: 'x',
      y: 'y',
      z: 'z',
      rotation: 'rot',
      rail: 'rail',
      lockRail: 'Lock rail',
      unlockRail: 'Unlock rail',
      railLockDisabledTooltip: 'Robot must be in free mode to lock the rail',
    },
    pathTrainer: {
      orientations: {
        LANDSCAPE: 'Landscape',
        REVERSE_LANDSCAPE: 'Reverse landscape',
        PORTRAIT: 'Portrait',
        REVERSE_PORTRAIT: 'Reverse portrait',
      },
      selectedApproachPath: 'Selected approach path',
      testTransport: 'Test transport',
      testTransportDialog: {
        pickOnly: 'Pick only',
        placeOnly: 'Place only',
        selectAction: 'Select an action',
        error: 'Failed to test transport. Please try again.',
        motionProfileRunOnly:
          'Applies to this test run only — it isn’t saved to the path.',
      },
      slotStatus: {
        incomplete: 'Incomplete',
        gxpDescription: 'Change slot status to {{status}}',
        updateStatusError: 'Failed to update slot status',
        removeApproachPath: 'Remove approach path',
        removePathDialog: {
          title: 'Remove path?',
          description:
            'This will permanently remove the {{orientation}} path from this slot. This action cannot be undone.',
        },
      },
      slot: '{{name}}',
      selectOrientation: 'Please select orientation',
      goToWaypoint: 'Move robot to waypoint',
      goToWaypointError: 'Failed to go to waypoint',
      deleteWaypoint: 'Remove waypoint',
      reorderWaypoint: 'Reorder waypoint',
      replaceWaypoint: 'Replace coordinates',
      addNewWaypoint: 'Add waypoint',
      waypointTable: 'Paths',
      addOrientation: 'Add orientation',
      slotsLabel: 'Slots ({{slotNumber}})',
      approachPathLabel: 'Approach path ({{pathCount}})',
      approachHeight: 'Delta',
      editWaypoint: 'Edit coordinates',
      editWaypointError: 'Failed to update waypoint',
      waypointActions: 'Waypoint actions',
      deleteWaypointError: 'Failed to delete waypoint',
      replaceWaypointError: 'Failed to replace waypoint',
      reorderWaypointError: 'Failed to reorder waypoint',
      updateApproachHeightError: 'Failed to update approach height',
      updateMotionProfileError: 'Failed to update motion profile',
      motionProfile: {
        info: 'Controls how the robot moves along this path.',
        default: 'Default',
        safetyNote:
          'The applied motion is the safest option across the robot configuration, the labware settings, and this path’s settings.',
        pathType: 'Path type',
        straight: 'Straight',
        notStraight: 'Not straight',
        transition: 'Transition',
        blended: 'Blended',
        notBlended: 'Not blended',
      },
      emptyState: {
        gettingStartedTitle: 'Getting started',
        gettingStartedBody:
          'Position the robot with the labware on the slot and add the first waypoint. Then move the robot away from the slot and continue adding waypoints to define the approach path.',
      },
    },
    instrumentList: {
      reachableDevices: 'Reachable devices',
    },
    errors: {
      jogFailed: 'Jog failed. Please try again.',
      waypointUnreachable:
        "The robot can't reach this position. Check the coordinates are within range.",
      testMoveFailed: "The robot couldn't complete the move. Please try again.",
    },
  },
  motionTimings: {
    title: 'Timings',
    collected: 'Collected',
    stale: 'Stale',
    uncollected: 'Uncollected',
    uncollectable: 'Uncollectable',
    collectTimings: 'Collect timings...',
    collectAll: 'Collect all timings',
    collectMissingAndStale: 'Collect missing & stale only',
    collecting: 'Collecting {{completed}}/{{total}} motions',
    collectionFailed: 'Collection failed',
    collectionLostTrack:
      'Lost track of the collection job — the service may have restarted. Retry?',
    // Typed collection-failure messages, keyed off the error __typename the
    // BFF returns on a FAILED job. Each names the likely cause + remediation.
    collectionError: {
      motionFailed:
        'Timing collection stopped — a robot movement failed. The robot may have collided with or been obstructed by an instrument. Make sure the robot and the surrounding area are clear, re-check that position’s training, then run collection again.',
      timedOut:
        'Timing collection stopped — a robot movement didn’t complete in time. Check the robot is powered, connected and unobstructed, then run collection again.',
      notTrained:
        'This device has no trained positions to collect. Train at least one, then run collection again.',
      generic:
        'Timing collection failed. Check the robot and try again; if it keeps happening, contact support.',
      affected: 'Affected: {{instrument}}, slot {{slot}}',
      affectedInstrument: 'Affected: {{instrument}}',
      affectedSlot: 'Affected: slot {{slot}}',
    },
    // Header warning icon
    attentionTooltip_one:
      '{{count}} timing needs attention (stale or uncollected)',
    attentionTooltip_other:
      '{{count}} timings need attention (stale or uncollected)',
    // Status-definitions popover
    statusDefinitions: 'Status definitions',
    collectedDefinition:
      'Successfully recorded and up to date. No changes to approach path since collection.',
    staleDefinition:
      'Previously collected but no longer up to date due to approach path changes. Needs to be recollected.',
    uncollectedDefinition: 'Can be timed but hasn’t been yet.',
    uncollectableDefinition:
      'Cannot be timed. Approach path not properly configured.',
    // Shuttle-variant definitions — same statuses, but the underlying
    // signal is the shuttle position (not an approach path), so the
    // operator-facing wording swaps to match.
    collectedDefinitionShuttle:
      'Successfully recorded and up to date. No changes to position since collection.',
    staleDefinitionShuttle:
      'Previously collected but no longer up to date due to position changes. Needs to be recollected.',
    uncollectedDefinitionShuttle: 'Can be timed but hasn’t been yet.',
    uncollectableDefinitionShuttle:
      'Cannot be timed. Position not properly configured.',
    // Aria labels
    openCollectMenu: 'Choose collection mode',
    openStatusDefinitions: 'Show status definitions',
  },
  tasks: {
    labwareUsage: {
      title: 'Labware usage',
      unitsConsumed: 'Units consumed',
      unitsConsumedFor: 'Units consumed for {{labware}}',
    },
    errorHandling: {
      label: 'Error handling',
      addAutoRetryButton: 'Add auto-retry',
      addRecoveryInstructionsButton: 'Add recovery instructions',
      autoRetry: {
        cardTitle: 'Auto-retry',
        removeLabel: 'Remove auto-retry',
      },
      recoveryInstructions: {
        cardTitle: 'Recovery instructions',
        removeLabel: 'Remove recovery instructions',
      },
      maxRetries: 'Number of retries',
      maxRetriesError: 'Number of retries must be between 1 and 10',
      applyTo: 'Apply to',
      scopeLabel: 'Error code scope',
      scope: {
        all: 'All error codes',
        selected: 'Selected error codes',
      },
      selectionPrompt: 'Select error codes to apply auto-retry on:',
      codes: {
        // Universal
        COMM_TIMEOUT: 'Communication timeout',
        COMM_ERROR: 'Communication error',
        INIT_FAILED: 'Initialization failed',
        NOT_INITIALIZED: 'Not initialized',
        DEVICE_ERROR: 'Device error',
        COMMAND_FAILED: 'Command failed',
        OPERATION_TIMEOUT: 'Operation timeout',
        INVALID_PARAMETER: 'Invalid parameter',
        DEVICE_BUSY: 'Device busy',
        DEVICE_NOT_READY: 'Device not ready',
        EMERGENCY_STOP: 'Emergency stop',
        // Door / Hatch
        DOOR_OPEN: 'Door open',
        DOOR_CLOSED: 'Door closed',
        DOOR_JAM: 'Door jammed',
        DOOR_OPEN_TIMEOUT: 'Door open timeout',
        DOOR_CLOSE_TIMEOUT: 'Door close timeout',
        // Temperature
        TEMP_OUT_OF_RANGE: 'Temperature out of range',
        TEMP_TIMEOUT: 'Temperature timeout',
        TEMP_SENSOR_ERROR: 'Temperature sensor error',
        // Plate / Labware
        NO_PLATE_FOUND: 'No plate found',
        TRANSFER_FAILED: 'Transfer failed',
        SLOT_OCCUPIED: 'Slot occupied',
        SLOT_EMPTY: 'Slot empty',
        // Seal / Peel
        SEAL_FAILED: 'Seal failed',
        PEEL_FAILED: 'Peel failed',
        // Cap / Uncap
        CAP_FAILED: 'Capping failed',
        UNCAP_FAILED: 'Uncapping failed',
        // Motor / Mechanical
        MOTOR_ERROR: 'Motor error',
        IMBALANCE_DETECTED: 'Imbalance detected',
        HOME_FAILED: 'Home failed',
        POSITION_ERROR: 'Position error',
        COLLISION_DETECTED: 'Collision detected',
        // Transport
        ITEM_LOST: 'Item lost',
        ITEM_MISSING: 'Item missing',
        // Liquid Handler
        METHOD_NOT_FOUND: 'Method not found',
        METHOD_FAILED: 'Method failed',
        SOFTWARE_CRASH: 'Software crash',
        PROTOCOL_ERROR: 'Protocol error',
        // Centrifuge
        SPIN_TIMEOUT: 'Spin timeout',
        HATCH_OPEN_TIMEOUT: 'Hatch open timeout',
        HATCH_CLOSE_TIMEOUT: 'Hatch close timeout',
        // Workflow logic
        CONDITIONAL_EVALUATION_FAILED: 'Conditional evaluation failed',
      },
      codeDescriptions: {
        // Universal
        COMM_TIMEOUT: 'Communication timeout with device (serial, IP, USB)',
        COMM_ERROR: 'Failed to read or write to device, or unexpected response',
        INIT_FAILED: 'Connection or initialization failed',
        NOT_INITIALIZED: 'Driver used before connection was established',
        DEVICE_ERROR: 'Catch-all for vendor-specific hardware errors',
        COMMAND_FAILED: 'Device did not acknowledge or execute command',
        OPERATION_TIMEOUT: 'Action did not complete within expected time',
        INVALID_PARAMETER:
          'Parameter out of range or invalid for current device state',
        DEVICE_BUSY: 'Device is busy with another operation',
        DEVICE_NOT_READY:
          'Device cannot execute the requested action in its current state',
        EMERGENCY_STOP: 'Emergency stop activated on the device',
        // Door / Hatch
        DOOR_OPEN: 'Door is open when it should be closed',
        DOOR_CLOSED: 'Door is closed when it should be open',
        DOOR_JAM: 'Door mechanism is stuck or jammed',
        DOOR_OPEN_TIMEOUT: 'Door did not open within expected time',
        DOOR_CLOSE_TIMEOUT: 'Door did not close within expected time',
        // Temperature
        TEMP_OUT_OF_RANGE: 'Temperature is outside the acceptable range',
        TEMP_TIMEOUT: 'Failed to reach target temperature within expected time',
        TEMP_SENSOR_ERROR: 'Temperature sensor is defective or unplugged',
        // Plate / Labware
        NO_PLATE_FOUND: 'No plate detected at expected position',
        TRANSFER_FAILED: 'Plate transfer operation failed',
        SLOT_OCCUPIED: 'Target slot already contains labware',
        SLOT_EMPTY: 'Source slot has no labware',
        // Seal / Peel
        SEAL_FAILED: 'Seal operation failed',
        PEEL_FAILED: 'Peel operation failed',
        // Cap / Uncap
        CAP_FAILED: 'Capping operation failed — verify cap and tube alignment',
        UNCAP_FAILED:
          'Uncapping operation failed — verify cap and tube alignment',
        // Motor / Mechanical
        MOTOR_ERROR: 'Motor stall, overcurrent, or driver fault',
        IMBALANCE_DETECTED: 'Load imbalance detected during rotation',
        HOME_FAILED: 'Homing operation failed',
        POSITION_ERROR: 'Failed to reach target position',
        COLLISION_DETECTED: 'Unexpected physical contact detected',
        // Transport
        ITEM_LOST: 'Labware dropped or became untracked during transport',
        ITEM_MISSING: 'Expected labware not found at station',
        // Liquid Handler
        METHOD_NOT_FOUND: 'Protocol or method file not found',
        METHOD_FAILED: 'Protocol execution failed',
        SOFTWARE_CRASH: 'Vendor instrument software crashed',
        PROTOCOL_ERROR: 'Protocol validation or execution error',
        // Centrifuge
        SPIN_TIMEOUT: 'Spin cycle did not complete within expected time',
        HATCH_OPEN_TIMEOUT: 'Hatch did not open within expected time',
        HATCH_CLOSE_TIMEOUT: 'Hatch did not close within expected time',
        // Workflow logic
        CONDITIONAL_EVALUATION_FAILED:
          'A conditional step could not be evaluated, often because expected data was not yet available. Retrying may succeed once the required data has been generated.',
      },
    },
    mockBehaviour: {
      label: 'Mock behaviour',
      addButton: 'Add mock behaviour',
      success: 'Success',
      useExecutionTime: 'Use execution time',
      executionTime: 'Execution time (seconds)',
      executionTimeError: 'Execution time must be between 0 and 3600 seconds',
      removeLabel: 'Remove mock behaviour',
    },
    types: {
      analyze: 'Analyze',
      aspirate: 'Aspirate',
      cap: 'Cap',
      dispense: 'Dispense',
      evaporate: 'Evaporate',
      extract: 'Extract',
      incubate: 'Incubate',
      manual_task: 'Manual task',
      peel: 'Peel',
      read: 'Read',
      rinse: 'Rinse',
      run_liquid_handler: 'Run liquid handler',
      run_protocol: 'Run protocol',
      scan_barcode: 'Scan barcode',
      seal: 'Seal',
      shake: 'Shake',
      spin: 'Spin',
      store: 'Store',
      thermocycle: 'Thermocycle',
      ultrasonicate: 'Ultrasonicate',
      uncap: 'Uncap',
      wash: 'Wash',
    },
    properties: {
      labware_and_deck: {
        labware_and_deck: 'Labware & deck',
        startSlotAria: 'Start slot for {{labware}}',
        endSlotAria: 'End slot for {{labware}}',
      },
      accessories: {
        addAccessory: 'Add accessory',
        accessory: 'Accessory',
        actionsColumn: 'Remove accessory',
        removeAria: 'Remove {{name}}',
      },
      task_instructions: 'Task instructions',
      selectInstrument: 'Select instrument',
      addDescription: 'Add description',
      editorPlaceholder: "Write or type '/' for commands...",
      updateDescription: 'Update description',
      uploadFailed: 'Failed to upload media. Please try again.',
      dataCapture: {
        title: 'Data capture',
        tooltip:
          'Data the operator will capture and provide as part of this action',
        add: 'Add data capture',
        namePlaceholder: 'Enter name',
        descriptionOptional: '(optional)',
        minValue: 'Min value',
        maxValue: 'Max value',
        types: {
          text: 'Text',
          number: 'Number',
          boolean: 'Boolean',
          duration: 'Duration',
          file: 'File',
        },
      },
      signatureConfig: {
        modalTitle: 'Configure signature',
        requirementLabel: 'Signature requirement',
        requirement: {
          singleDescription: 'Author of action',
          dualDescription: 'Author and approver or witness of action',
        },
        primarySignature: 'Primary signature',
        primaryMeaningLabel: 'Meaning of signature',
        primaryMeaningValue:
          'Authorship. Action performed and recorded accurately.',
        guidanceForSigner: 'Guidance for signer',
        guidanceForSignerPlaceholder: 'Guidance shown to the signer',
        secondarySignature: 'Secondary signature',
        removeSecondary: 'Remove secondary signature',
        secondaryReason: 'Secondary reason for signature',
        secondaryReasonOptions: {
          witness: 'Witness by secondary user',
          approval: 'Approval by secondary user',
        },
        secondaryFrom: 'Secondary signature from',
        save: 'Save configuration',
      },
    },
    affixTask: {
      preAndPostTasks: 'Pre & post tasks',
      preTasks: 'Pre-tasks',
      postTasks: 'Post-tasks',
      addTask: 'Add task',
      removeAction: 'Remove action',
      noActionsAvailable: 'No sub-actions available',
      deleteConfirmTitle: 'Delete task',
      deleteConfirmDescription:
        'Are you sure you want to delete "{{actionName}}"? This action cannot be undone.',
      reorderAction: 'Reorder action',
      timeSensitive: 'Time sensitive',
    },
  },
  canvas: {
    debugDialog: {
      triggerTooltip: 'Debug workflow data',
      title: 'Workflow debug data',
    },
    loadError: {
      title: 'Failed to load workflow',
    },
    workflowResourceName: 'workflow',
    conditionalNode: {
      notFound: 'Error: Conditional not found',
    },
    panelHeader: {
      simulation: 'Simulation',
      build: 'Build',
    },
    floatingMenu: {
      showRelations: 'Show relations',
      hideRelations: 'Hide relations',
      addFrame: 'Frame',
      changeFrameColor: 'Change frame color',
      renameFrame: 'Rename frame',
      selectOrMoveFrame: 'Select or move frame',
      undo: 'Undo',
      redo: 'Redo',
    },
    clipboard: {
      nodesCopiedHeader_one: '{{count}} node copied from LINQ canvas',
      nodesCopiedHeader_other: '{{count}} nodes copied from LINQ canvas',
    },
    zoom: {
      fitToSelection: 'Fit to selection',
      fitToScreen: 'Fit to screen',
    },
    frameColors: {
      orange: 'Orange',
      amber: 'Amber',
      lime: 'Lime',
      emerald: 'Emerald',
      teal: 'Teal',
      cyan: 'Cyan',
      sky: 'Sky',
      indigo: 'Indigo',
    },
    nodeLibrary: {
      searchPlaceholder: 'Search tasks...',
      searchTooltip: 'Search',
      clearSearch: 'Clear search',
      showAllTasks: 'Show all tasks',
      unavailableTaskTooltip:
        'No device available for this task in the selected instrument group',
      unavailableTaskIcon: 'No device available',
    },
    setupInstructions: {
      title: 'Setup actions',
      cleanupTitle: 'Cleanup actions',
      closeButton: 'Close instructions sidebar',
      addInstruction: 'Add instruction',
      selectInstructionType: 'Select instruction type',
      deviceProperty: 'Device property',
      device: 'Device',
      driverVersion: 'Driver version',
      selectDevice: 'Select device',
      addProperty: 'Add property',
      noInstrumentsAvailable: 'No instruments available',
      timeEstimate: 'Time estimate',
      noConfigurableProperties:
        'This driver has no configurable properties. Select a different driver or cancel.',
      instructionName: 'Instruction name',
      instructionNamePlaceholder: 'Enter instruction name',
      noDevice: 'No device (general instruction)',
      clickToAddDescription: 'Click to add description...',
      editDescription: 'Edit description',
      action: 'Action',
      command: 'Command',
      selectCommand: 'Select command',
      addAction: 'Add action',
      noActionsAvailable: 'No actions available for this driver',
      manifestFetchError: 'Failed to fetch device configuration schema',
      placeLabware: 'Place labware',
      removeLabware: 'Remove labware',
      slotDeterminedByPlan: '# and slot determined by plan',
      locationDeterminedByPlan: 'Device determined by plan',
      labwareLoadingDeleteDisabled:
        'Labware loading instructions are added automatically and cannot be deleted',
      addFunction: 'Add function',
      types: {
        configureDescription: 'Set device configuration values',
        manualDescription: 'Operator performs a manual action',
        deviceCommand: 'Device command',
        deviceCommandDescription: 'Execute commands on a device',
        function: 'Function',
        functionDescription: 'Run inline Python code',
        functionDependencies: 'Run after',
        functionDependenciesDescription:
          'Select instructions that must complete before this function runs. If none selected, runs after the previous instruction.',
      },
    },
    processInstructions: {
      empty:
        'No instructions. Select a workflow automation to see its setup and cleanup actions.',
      noStepActions: 'No actions for this step.',
      alreadyLoaded: {
        title: 'Labware already loaded in {{workflowName}} workflow',
        viewButton: 'View initial loading instruction',
        description:
          'Labware from an upstream workflow will be transported automatically by the system from the ending location of the previous workflow to the location of the first task in this workflow when this workflow begins.',
      },
    },
    combineGroups: {
      combineSelected: 'Combine {{count}} selected steps or groups',
      selectMoreHint: 'Select another step or group to combine them.',
      nothingToGroup: 'There is nothing to group this with.',
      intro:
        'Select workflows to group. Grouped workflows share one setup and cleanup: the setup finishes before any workflow in the group starts, and the cleanup runs only once they have all finished.',
      link: 'Link',
      unlink: 'Unlink',
      linkedHint: 'Setup and cleanup are linked.',
      ungroup: 'Ungroup',
      removeStep: 'Remove step from group',
      parallelTag: 'parallel',
      parallelHint:
        'Parallel steps automatically share setup and cleanup. Change this by editing the parallel relation on the canvas.',
      selectStepNamed: 'Select {{name}} to combine',
      selectGroupNamed: 'Select group ({{steps}}) to combine',
    },
    parameters: {
      groupByTask: 'Group by task',
      groupByStep: 'Group by step',
      flatList: 'Flat list',
      close: 'Close parameters sidebar',
      fieldTypes: {
        field: 'Field',
        string: 'String',
        number: 'Number',
        integer: 'Integer',
        boolean: 'Boolean',
        array: 'Array',
        object: 'Object',
        file: 'File',
      },
    },
    taskAutomation: {
      noCompatibleInstruments: {
        title: 'No compatible instruments',
        description:
          'Instrument group {{instrumentGroupName}} does not have any instruments compatible with this {{actionName}} task.',
      },
    },
    accessories: {
      title: 'Accessories',
      closeButton: 'Close accessories sidebar',
      addAccessory: 'Add balance plate',
      noAccessories: 'No accessories defined',
      newAccessory: 'New balance plate',
      editAccessory: 'Edit balance plate',
      validation: {
        nameRequired: 'Enter a name for the balance plate',
        labwareTypeRequired: 'Choose a labware type',
        instrumentRequired: 'Choose a home instrument',
        slotRequired: 'Enter a home slot',
      },
      homeLocationHint:
        'This balance plate always returns to the same home location when not in use',
      locationSummary: '{{instrument}} · slot {{slot}}',
      slotConflict:
        'Slot {{slot}} on this instrument is already used by {{name}}. Choose a different slot.',
      noHomeLocation: 'No home location set',
      usedIn: 'Used in:',
      notUsed: 'Not assigned to any task',
      editAria: 'Edit {{name}}',
      deleteAria: 'Delete {{name}}',
      deleteConfirmDescription:
        'This accessory is assigned to the tasks below. Deleting it will remove it from them.',
      affectedTasks: 'Affected tasks:',
    },
    variables: {
      title: 'Variables',
      closeButton: 'Close variables sidebar',
      addVariable: 'Add variable',
      selectVariableType: 'Select variable type',
      noVariables: 'No variables defined',
      newVariable: 'New variable',
      editVariable: 'Edit variable',
      variableName: 'Variable name',
      numberType: 'Number type',
      wholeNumber: 'Whole number',
      decimalNumber: 'Decimal number',
      defaultValue: 'Default value',
      validRange: 'Valid range',
      min: 'Min',
      max: 'Max',
      description: 'Description',
      descriptionPlaceholder: 'Enter a description...',
      uploadFile: 'Upload file',
      selectFile: 'Select file',
      removeFile: 'Remove file',
      parameter: 'Parameter',
      parameterTooltip:
        'Mark as parameter to allow this value to be set when creating a run',
      parameterUnsupportedFile: 'File parameters are not supported yet',
      parameterUnsupportedKind:
        'Parameters are not supported for this type yet',
      useCount: 'Used by',
      deleteConfirmTitle: 'Delete "{{name}}"',
      deleteConfirmDescription:
        'This variable is used by properties in the following nodes. Deleting it will clear the value from these properties.',
      affectedProperties: 'Affected properties:',
      uploading: 'Uploading...',
      uploadFailure: 'File upload failed',
      uploadMissingDevicePath: 'Upload did not return a device path',
      errors: {
        defaultBelowMin: 'Default value is below the minimum ({{min}})',
        defaultAboveMax: 'Default value is above the maximum ({{max}})',
        minExceedsMax: 'Minimum must not exceed maximum',
      },
      types: {
        number: 'Number',
        numberDescription: 'Numeric value (whole or decimal)',
        text: 'Text',
        textDescription: 'String value',
        boolean: 'Boolean',
        booleanDescription: 'True or false value',
        duration: 'Duration',
        durationDescription: 'Time duration value',
        file: 'File',
        fileDescription: 'File upload',
      },
    },
    valueChip: {
      appliedVariable: 'Applied variable',
      appliedParameter: 'Applied parameter',
      appliedInputData: 'Applied input data',
      appliedSecret: 'Secret reference',
      appliedAsset: 'Asset library file',
      assetRevision: 'Revision',
      revisionTag: 'v{{revision}}',
      defaultValue: 'Default',
    },
    propertiesPanel: {
      slotDisabledNoLabware: 'No labware connected',
      relation: 'Relation',
      executionMode: {
        label: 'Execution mode',
        placeholder: 'Select an execution mode',
      },
    },
    relations: {
      source: 'Source',
      target: 'Target',
      edgeAriaLabel: 'Relation from {{source}} to {{target}}',
      addTimeConstraint: 'Add time constraint',
      dependency: {
        title: 'Dependency',
        happens: 'happens',
        before: 'Before',
        after: 'After',
        parallel: 'Parallel',
        disabledReasonSingleOption:
          'Only one direction is valid here. The other would conflict with the labware flow or an existing dependency.',
        disabledReasonNoOptions:
          'No dependency direction is valid between these tasks (they share labware). You can still add a time constraint.',
        disabledReasonMissingLabware:
          'Add labware connections to both tasks before configuring a dependency direction.',
      },
      timeConstraint: {
        deleteTooltip: 'Delete time constraint',
        hardLimits: 'Hard limits',
        preferredTiming: 'Preferred timing',
        preferredDuration: 'Preferred duration',
        priority: 'Priority',
        weightHint:
          'How strongly the planner favours this preferred duration relative to other timing targets. Never overrides overall plan duration.',
        targetOutOfRange:
          'Preferred duration is outside the min–max range, so the planner cannot reach it.',
      },
    },
  },
  studio: {
    view: {
      abstract: 'Abstract',
      list: 'List',
    },
    robotTraining: {
      title: 'Robot Teaching',
    },
    deviceType: {
      robot: 'Robot',
      robots: 'Robots',
      shuttle: 'Shuttle',
      shuttles: 'Shuttles',
      safety: 'Safety Controller',
      lighting: 'Lighting System',
      controller: 'Controller',
      controllers: 'Controllers',
    },
    controllerSection: {
      connectedTo: 'Connected to',
      addressing: 'Addressing',
      errors: {
        loadingDeviceData: 'Loading device data — try again in a moment',
        alreadyAssigned: 'Device already has a controller assigned',
        incompatibleDevice:
          'Incompatible device: "{{model}}" does not support the "{{protocol}}" protocol',
        protocolMismatch:
          'Protocol mismatch: controller uses "{{ctrlProtocol}}" but device uses "{{childProtocol}}"',
        linkFailed: 'Failed to link device to controller — please retry',
        unlinkFailed: 'Failed to unlink device from controller — please retry',
        saveFailed: 'Failed to save controller configuration — please retry',
      },
    },
    createGroupDialog: {
      title: 'Create new group',
      placeholder: {
        name: 'Enter group name...',
      },
      device: '{{count}} Device',
      devices: '{{count}} Devices',
      summary: 'Summary',
      buttons: {
        create: 'Create group',
      },
      errors: {
        createFailed: 'Could not create group. Please try again.',
      },
    },
    deviceGroupErrors: {
      duplicateName: 'A group with this name already exists.',
    },
    groupDetailsPanel: {
      title: '{{name}} details',
      placeholder: {
        groupName: 'Enter group name',
        description: 'Enter group description',
      },
      sections: {
        groupSize: 'Group size',
      },
      cards: {
        totalDevices: 'Total devices',
        aria: {
          totalDevicesCount: '{{count}} total devices',
        },
      },
      buttons: {
        saveName: 'Save group name',
      },
      errors: {
        emptyName: 'Group name cannot be empty',
        renameFailed: 'Could not rename group. Please try again.',
      },
      permissionRequired: 'You do not have permission to rename device groups',
    },
    instrumentGroupSelector: {
      viewDeviceBreakdown: 'View device breakdown',
      searchPlaceholder: 'Search group...',
    },
    instrumentGroupCard: {
      instrumentWithMarkup: '<0>Instrument</0> <1>{{count}}</1>',
      instrumentsWithMarkup: '<0>Instruments</0> <1>{{count}}</1>',
      warnings_one: '{{count}} device has warnings',
      warnings_other: '{{count}} devices have warnings',
      menu: {
        aria: {
          actionsMenu: 'Group {{groupName}} actions menu',
        },
      },
      aria: {
        selectGroup: 'Select group {{groupName}}',
      },
      deleteDialog: {
        title: 'Delete instrument group',
        description:
          'Are you sure you want to delete "{{groupName}}"? This action cannot be undone.',
      },
      duplicateDialog: {
        title: 'Duplicate instrument group',
        description: 'Enter a name for the duplicated group.',
        errors: {
          nameConflict: 'A group with this name already exists.',
          notFound:
            'This group no longer exists. Refresh the page and try again.',
          unsupportedType: 'This group type cannot be duplicated.',
          unknown: 'Failed to duplicate group. Please try again.',
        },
      },
      duplicateSuccess: 'Group duplicated',
    },
    deviceEditOverlay: {
      addToGroup: 'Add device to group',
    },
    registerDeviceDialog: {
      title: 'Register device',
      selectDevice: 'Select device {{vendor}} {{model}}',
      filters: {
        systems: 'Systems',
      },
      placeholder: {
        search: 'Search...',
      },
      tableHeaders: {
        quantity: 'Quantity',
      },
      selection: {
        none: 'No devices selected',
        device: '{{count}} device selected',
        devices: '{{count}} devices selected',
      },
      buttons: {
        register: 'Register',
        registering: 'Registering...',
      },
      errors: {
        loadFailed: 'Failed to load devices',
      },
      empty: 'No devices found',
    },
    registerSafetySystemDialog: {
      success: 'Safety system registered successfully',
      error: 'Failed to register safety system',
    },
    registerLightingSystemDialog: {
      success: 'Lighting system registered successfully',
      error: 'Failed to register lighting system',
    },
    lightingPropertiesPanel: {
      lightingDriver: 'Lighting Driver',
      connectedGroups: 'Connected Groups',
      connectedGroupsPlaceholder: 'Select connected groups',
      connectedGroupsEmpty: 'No module groups available',
      connectedGroupsNoneSelected: 'No groups selected.',
      connectedGroupsRequired:
        'Select at least one connected group before deploying.',
      removeConnectedGroup: 'Remove connected group',
      editingDisabledWhileDeployed:
        'Settings cannot be changed while the lighting system is deployed. Disable it first.',
      errors: {
        deployFailed: 'Failed to deploy lighting system',
        undeployFailed: 'Failed to undeploy lighting system',
        setConnectedGroupsFailed: 'Failed to update connected groups',
        loadGroupsFailed: 'Failed to load module groups',
        patchFailed: 'Failed to update lighting system',
        deployed:
          'Cannot change lighting system settings while it is deployed. Disable it first.',
        notFound: 'Lighting system not found',
        moduleMissing:
          'Required lighting module is missing. Re-register the lighting system.',
        groupNotFound: 'One of the selected groups no longer exists',
        groupWrongType: 'One of the selected groups is not a standard group',
      },
    },
    safetyPropertiesPanel: {
      safetyAdaptor: 'Safety Adaptor',
      version: 'Version',
      enable: 'Enable',
      disable: 'Disable',
      deploying: 'Deploying...',
      undeploying: 'Undeploying...',
      connecting: 'Connecting...',
      disconnecting: 'Disconnecting...',
      editingDisabledWhileDeployed:
        'Settings cannot be changed while the safety system is deployed. Disable it first.',
      errors: {
        deployFailed: 'Failed to enable the safety system.',
        undeployFailed: 'Failed to disable the safety system.',
        patchFailed: 'Failed to update safety system',
      },
      status: {
        eStopped: 'E-Stop',
        fStopped: 'F-Stop',
        fStopping: 'F-Stopping',
        disabled: 'Disabled',
        running: 'Running',
        paused: 'Paused',
      },
    },
    propertiesPanel: {
      emptyState: 'Select a node to view its properties',
      sections: {
        details: 'Details',
        components: 'Components',
        connection: 'Connection',
        robotSettings: 'Robot settings',
        shuttlePositions: 'Shuttle positions',
        slots: 'Slots',
        capacity: 'Capacity',
        driver: 'Advanced',
        state: 'State',
        controls: 'Controls',
        methods: 'Assets',
      },
      methods: {
        empty: 'No methods added',
        addMethod: 'Add asset',
        removeMethod: 'Remove method',
        added: 'Method linked to device',
        addFailed: 'Failed to link method',
        removed: 'Method removed',
        removeFailed: 'Failed to remove method',
        addToDevice: 'Add to device',
        selectPackageHint: 'Select a package first',
        noLibraryMethods: 'No methods in this package',
        package: 'Package',
        method: 'Method',
        createPackage: 'Create new package',
        tabs: {
          browseMachine: 'Browse machine',
          fromLibrary: 'From library',
        },
      },
      components: {
        empty: 'No components defined',
      },
      state: {
        empty: 'No state fields available',
        readOnly: 'Read only',
        unit: 'Unit: {{unit}}',
      },
      tasks: {
        empty: 'No tasks available',
        stepAction: '{{action}}',
        stepTransportIn: 'Transport in',
        stepTransportOut: 'Transport out',
      },
      controls: {
        endSession: 'End session',
        disconnecting: 'Disconnecting',
        inactivityTimeout: 'Driver undeployed — no activity for 10 minutes',
        noActions: 'No actions available',
        trigger: 'Trigger',
        bookingDuration: 'Session length',
        bookingDurationOption: '{{minutes}} min',
        timeRemainingValue: '{{minutes}}m {{seconds}}s',
        timeRemainingLow: 'Session ends in under a minute',
        timeRemainingExpired: 'Session has ended',
        extend: 'Extend +{{minutes}} min',
        extendFailed: 'Could not extend session',
        move: 'Move',
        configurationRequiredFields: 'Required fields',
        triggerDialog: {
          title: 'Trigger: {{action}}',
          success: 'Action completed successfully',
          result: 'Result',
          error: 'Action failed',
          unexpectedError: 'An unexpected error occurred',
        },
        moveDialog: {
          title: 'Move shuttle',
          description:
            'Move the shuttle to a coordinate within its configured range.',
          coordinates: 'Coordinates',
        },
        errors: {
          cannotConnectLocked: 'Cannot connect while device is locked',
          cannotDisconnectLocked:
            'Cannot disconnect while device is locked by a workflow',
          cannotTriggerActionLocked:
            'Cannot trigger action while device is locked by a workflow',
          triggerActionFailed: 'Failed to trigger action',
          deviceUnreachable:
            "The device isn't responding. Check it's switched on and connected, then try again.",
          connectionRejected:
            "Couldn't connect to the device. Check its connection settings (e.g. address or port), then try again.",
          couldNotStart:
            "Couldn't start the device. Check it's switched on and connected, then try again.",
          connectionSecrets:
            "Couldn't read the device's saved connection details. Check its configuration, then try again.",
          inUse: "This device is currently in use. Try again once it's free.",
          sessionEnded: 'Your device session has ended. Reconnect to continue.',
          actionTimedOut:
            "The device didn't respond in time. Please try again.",
          actionFailed:
            "The device couldn't complete the action. Please try again.",
          unavailable:
            'Something went wrong. Please try again — if it keeps happening, contact Automata.',
        },
      },
      slotConfiguration: {
        customized: 'customized',
        metric: 'mm',
        accessibility: 'Accessibility',
        addSlot: 'Add slot',
        deleteSlot: 'Delete slot',
        overCapacity:
          'Storable slot count ({{count}}) exceeds capacity ({{capacity}})',
        columns: 'Columns',
        column: 'Column {{number}}',
        row: 'Row {{number}}',
        removeColumn: 'Remove column',
        slotsCount_one: '{{count}} slot',
        slotsCount_other: '{{count}} slots',
        slotsCountCustomized_one: '{{count}} slot ({{customized}} customized)',
        slotsCountCustomized_other:
          '{{count}} slots ({{customized}} customized)',
        accessibilityOptions: {
          storage: 'Storage',
          robotAccessible: 'Robot accessible',
          loadingBay: 'Loading bay',
          bin: 'Bin',
        },
        customizeSlots: 'Customize',
        loadingBays: 'Loading bays',
        addLoadingBay: 'Add loading bay',
        sharedWithInstrument: 'Shared with another instrument',
        selectInstrument: 'Select instrument…',
        transferStationSharedWith: 'Transfer station shared with',
        editConnection: 'Edit connection',
      },
      labels: {
        model: 'Model',
        image: 'Image',
        mockMode: 'Mock mode',
        version: 'Version',
        versionChannel: 'Version channel',
        prereleaseVersion: 'Prerelease version',
        prereleaseExpired:
          'This prerelease version is no longer available. Please switch to a stable version.',
      },
      versionChannels: {
        stable: 'Stable',
        prerelease: 'Prerelease',
      },
      selectVersion: 'Select version',
      selectPrereleaseVersion: 'Select prerelease version',
      searchPrereleaseVersion: 'Search prerelease versions',
      prereleaseUnstableWarning:
        'Prerelease versions may be unstable. Not recommended for production workflows.',
      emptyRelations: 'No connections',
      emptyShuttlePositions: 'No positions configured',
      robotSettings: {
        speedProfile: 'Speed profile',
        speedProfiles: {
          FAST: 'Fast',
          STANDARD: 'Standard',
          SLOW: 'Slow',
          GENTLE: 'Gentle',
        },
        railLength: 'Rail length',
        millimetres: 'mm',
        updateSettingsError:
          'Failed to update robot settings. Please try again.',
        safeRange: {
          title: 'Safe range of motion',
          description:
            'The range each axis or joint must be within for the robot to move to its home position automatically.',
          axes: {
            X: 'X',
            Y: 'Y',
            Z: 'Z',
            ROTATION: 'Rotation',
            RAIL: 'Rail',
          },
          addAxis: 'Add axis',
          joints: 'Joints',
          addJoint: 'Add joint',
          jointLabel: 'Joint {{index}}',
          minLabel: '{{label}} min',
          maxLabel: '{{label}} max',
          remove: 'Remove {{label}} safe range',
          setError: 'Failed to update the safe range. Please try again.',
          removeError: 'Failed to clear the safe range. Please try again.',
        },
      },
      shuttlePositions: {
        addPosition: 'Add position',
        removePosition: 'Remove position',
        duplicateName: 'A position with this name already exists',
        selectRobotPlaceholder: 'Select a robot',
        noRobotsConnected: 'No robots connected to this shuttle',
        addPositionError: 'Failed to add position. Please try again.',
        editPosition: 'Edit position',
        editPositionError: 'Failed to update position. Please try again.',
        setAsHomePosition: 'Set as home position',
        positionActions: 'Actions for {{name}}',
        coordinateRequired: 'Required',
      },
      emptyGroups: 'Not in any groups',
      unknownDevice: 'Unknown device',
      tableHeaders: {
        actions: 'Actions',
        groupName: 'Group name',
      },
      buttons: {
        close: 'Close properties panel',
        removeConnection: 'Remove connection',
        removeFromGroup: 'Remove from group',
      },
      validation: {
        invalidFormat: 'Invalid format',
        required: '{{name}} is required',
        tooLittle: 'Value must be at least {{value}}',
        tooBig: 'Value must be at most {{value}}',
      },
      connectionDisabledWhileConnected:
        'Connection cannot be configured while this device is connected. Please disconnect first.',
    },
    permissions: {
      devicesConfig: {
        write:
          "You don't have permission to modify device configuration. Ask your administrator to grant write:devices:config access",
        archive:
          "You don't have permission to delete devices. Ask your administrator to grant archive:devices:config access",
      },
      deviceGroups: {
        write:
          "You don't have permission to modify device groups. Ask your administrator to grant write:device_groups access",
      },
    },
    floatingMenu: {
      viewModes: {
        select: 'Select mode',
        relation: 'Relation mode',
        groupEdit: 'Group editing mode',
      },
      grouping: {
        createGroup: 'Select instruments to create a group',
      },
      display: {
        showExcluded: 'Show excluded items',
        hideExcluded: 'Hide excluded items',
      },
    },
    removeDialog: {
      title: 'Remove device from group',
      description:
        'Are you sure you want to remove "{{deviceName}}" from "{{groupName}}"?',
      confirm: 'Remove',
    },
    deleteDeviceDialog: {
      title_one: 'Delete device',
      title_other: 'Delete devices',
      description_one:
        'Are you sure you want to delete "{{deviceName}}"? You can register it again later.',
      description_other:
        'Are you sure you want to delete {{count}} devices? You can register them again later.',
      devicesToDelete: 'Summary ({{count}})',
    },
    gxp: {
      deleteDeviceGroup: 'Delete device group "{{groupName}}"',
      removeDeviceFromGroup:
        'Remove device "{{deviceName}}" from group "{{groupName}}"',
      deleteDevice_one: 'Delete device "{{deviceName}}"',
      deleteDevice_other: 'Delete {{count}} devices',
      removeConnection_one:
        'Remove connection between "{{sourceName}}" and "{{targetName}}"',
      removeConnection_other: 'Remove {{count}} connections',
    },
    removeConnectionDialog: {
      title_one: 'Remove connection',
      title_other: 'Remove connections',
      description_one:
        'Are you sure you want to remove the connection between "{{sourceName}}" and "{{targetName}}"?',
      description_other:
        'Are you sure you want to remove {{count}} connections?',
    },
    edge: {
      removeLink: 'Remove link between {{source}} and {{target}}',
    },
    errors: {
      saveCanvasFailed: 'Failed to save canvas layout.',
    },
    listView: {
      loading: 'Loading devices...',
      emptyState: {
        title: 'No devices',
        description: 'Register devices to see them listed here.',
        noDevicesInGroup: 'No devices in this group',
      },
      tableHeaders: {
        groups: 'Groups',
      },
      actions: {
        locateOnCanvas: 'Locate on canvas',
      },
      aria: {
        selectDevice: 'Select {{deviceName}}',
        locateDevice: 'Locate {{deviceName}} on canvas',
        moreActions: 'More actions for {{deviceName}}',
      },
    },
    status: {
      connected: 'Connected',
      connecting: 'Connecting',
      disconnected: 'Disconnected',
    },
    groupUsage: {
      checking: 'Checking for affected workflows and processes...',
      currentlyDeployed:
        'This group is currently deployed. Deleting it will disrupt active operations.',
      instrumentInActiveGroupWarning:
        'This instrument is in a device group that is currently active. Deleting it will disrupt active operations.',
      affectedWorkflows:
        'The following workflows and processes reference this device group: <0>{{groupName}}</0>.',
      automation: 'Automation: {{name}}',
      automationUnnamed: 'Unnamed automation',
      processExternalId: 'External ID: {{externalId}}',
      hasScheduledRuns: 'Active runs',
      blockedAction:
        'Remove these from the queue before {{action}} this group.',
      blockedActionDevice:
        'Remove these from the queue before removing this device.',
      configWarning:
        'Changing configuration may affect their execution. Are you sure?',
    },
  },
  canvasValidation: {
    emptyState: {
      noIssuesFound: 'No issues found',
      noMissingInputsFound: 'No missing inputs found',
      noErrorsFound: 'No errors found',
      adjustSearchTerms: 'Try adjusting your search terms',
      noIssuesMatchSearch: 'No issues match your search',
    },
    filters: {
      missingInput: 'Missing input',
    },
    searchPlaceholder: 'Search issues...',
    errors: 'Errors',
    noContent: 'No content',
    issues: 'Issues',
    closePanel: 'Close validation panel',
    issueItem: {
      location: 'Location:',
      node: 'Node:',
      relation: 'Relation:',
      field: 'Field:',
      message: 'Message:',
    },
    footer: {
      errors: 'Errors ({{total}})',
      missingInputs: 'Missing inputs ({{total}})',
      warnings: 'Warnings ({{total}})',
    },
    issueTitle: {
      invalidValue: 'Invalid value',
      deviceDataMissingForSimulationAndRunning:
        'Data missing in Studio - Required for simulation and running',
      deviceDataMissingForRunning:
        'Data missing in Studio - Required for running',
      missingInputForPlanningAndRunning:
        '{{message}} - Required for planning and running',
      missingInputForRunning: '{{message}} - Required for running',
    },
    warnings: {
      manualStepNotExecutable: {
        message:
          'Manual steps cannot be executed yet — simulating or running a process that contains one will fail',
        shortDescription: 'Manual steps not executable yet',
      },
    },
    requiredForPlanningAndRunning: 'Required for planning and running',
    requiredForRunning: 'Required for running',
    staleDataReference:
      'Stale data reference: the referenced output no longer exists',
    fields: {
      timeEstimate: 'Time estimate',
      minimumTime: 'Minimum time',
      maximumTime: 'Maximum time',
      startSlot: 'Start slot',
      endSlot: 'End slot',
      start: 'Start',
      end: 'End',
      claudeCredential: 'Token',
    },
    requiredMessage: '{{field}} is required',
    minExceedsMaxMessage: 'Min must be less than or equal to max',
    incompleteTimeConstraintMessage:
      'Set at least a minimum, maximum, or preferred duration.',
    liquidHandlerSingleDeviceMessage:
      'Task receiving labware from a liquid handler starting location must have a single device',
    liquidHandlerDeviceMismatchMessage:
      "Labware starting location must match the first task's device for liquid handler instruments",
    startingSlotRangeMessage:
      'Starting slot must be a valid slot or slot range (e.g. "1-5")',
    endSlotRangeMessage:
      'End slot must be a valid slot or slot range (e.g. "1-5")',
    instrumentNoLongerInGroupMessage:
      'The assigned instrument is no longer in the instrument group. Re-assign or remove the reference to simulate.',
    startLocationInstrumentNoLongerInGroupMessage:
      'The starting location instrument is no longer in the instrument group. Re-assign or remove the reference to simulate.',
    shortDescriptions: {
      required: 'Required',
      invalidNumber: 'Invalid number',
      mustBeInteger: 'Must be an integer',
      invalidFormat: 'Invalid format',
      variableOnEnum: 'Variable on enum',
      minAboveMax: 'Min > Max',
      slotMismatchWithDownstreamTask: 'Slot mismatch with downstream task',
      invalidSlotFormat: 'Invalid slot format',
      multipleDevicesOnLiquidHandlerTask:
        'Multiple devices on liquid handler task',
      liquidHandlerDeviceMismatch: 'Liquid handler device mismatch',
      incompleteTimeConstraint: 'Incomplete time constraint',
      invalidDurationRange: 'Invalid duration range',
      staleInstrument: 'Instrument not in group',
      staleDataReference: 'Stale data reference',
    },
  },
  controlRoom: {
    labwareDetails: {
      labwareId: 'Labware ID: {{labwareId}}',
      processId: 'Process ID: {{processId}}',
      title: 'Labware details',
    },
    openOperatorActions: 'Open operator actions',
    performRequiredAction: 'Perform required action',
    task: {
      retryPrefix: 'Retry: {{taskName}}',
    },
    labwareTable: {
      waitingOnHint: 'Task is waiting on {{taskName}} to complete.',
    },
    eventLog: {
      title: 'Event log',
      event: 'Event',
      eventType: 'Event type',
      byLabware: 'By labware',
      byEventType: 'By event type',
      searchLabware: 'Search labware',
      sortBy: 'Sort by {{column}}',
      refresh: 'Refresh',
      types: {
        replan: 'Replan',
        alert: 'Alert',
        other: 'Other',
      },
    },
    permissions: {
      exportReports:
        "You don't have permission to export reports. Ask your administrator to grant export:reports access",
      operatorActions: {
        read: "You don't have permission to view operator actions. Ask your administrator to grant read:operator_actions access",
      },
    },
    components: {
      abortLabwareBatch: {
        title: 'Abort labware batch',
        description: 'Select the batches you would like to abort',
        /** Display label for a batch identifier — interpolates the BFF id (e.g. "1" → "Batch 1"). */
        batchLabel: 'Batch {{batch}}',
        selector: {
          label: 'Select batches',
          placeholder: 'Select batches...',
          searchPlaceholder: 'Search batches',
          openLabel: 'Open batch selector',
          removeLabel: 'Remove batch {{batch}}',
        },
        table: {
          labwareName: 'Labware name',
          currentTask: 'Current task',
          currentLocation: 'Current location',
        },
        error: {
          loadFailed: 'Failed to load batches. Please try again.',
        },
      },
      abortConfirm: {
        title: 'Review how to abort impacted labware in this workflow',
        description:
          'The following labware will be aborted as part of this workflow. Review and confirm the abort settings before proceeding.',
        descriptionWithName:
          'The following labware will be aborted as part of the workflow {{workflowName}}. Review and confirm the abort settings before proceeding.',
        labwareMoveAlert: {
          /** Shown when one or more labware are mid-transport and the operator must physically move them before the abort can proceed. */
          transport: {
            title: 'Manual transport required before continuing',
            description:
              'The following labware are mid-transport. Move each one to the listed destination before continuing.',
            item: '{{labware}} → {{destination}}',
          },
          /** Shown when the user has selected Manual as the move type for one or more labware in the table. */
          hasManualLabware: {
            description:
              'Some labware requires manual intervention. Please follow the move instructions for each affected item.',
          },
        },
        labwareSection: {
          trigger: 'Impacted labware [{{count}}]',
          leaveAllInPlace: 'Leave all labware in place',
          search: 'Search labware',
          table: {
            labwareName: 'Labware name',
            currentTask: 'Current task',
            moveType: 'Move type',
            currentLocation: 'Current location',
            returnLocation: 'Return location',
          },
        },
        moveType: {
          automated: 'Automated',
          manual: 'Manual',
        },
        returnLocation: {
          outsideWorkcell: 'Outside workcell',
          startLocation: 'Start location',
        },
        reason: 'Provide a reason for aborting',
        errorLoadingPreview: 'Unable to load abort preview',
        gxp: {
          rerouteWorkflow: 'Reroute workflow labware',
          rerouteBatch: 'Reroute batch labware',
          abortBatch: 'Abort batch',
          resumeWorkflow: 'Resume workflow after failed reroute',
        },
        buttons: {
          confirm: 'Confirm abort',
        },
        errorRecovery: {
          resume: 'Resume workflow',
          keepInPlace: 'Abort workflow (keep all labware in place)',
        },
      },
      abortLabware: {
        title: 'Abort labwares',
        dialogDescription:
          'The following labware will be removed from this run. This action cannot be undone.',
        manualRemovalNotice:
          'You will need to manually remove the aborted labware from the workcell.',
        accordion: {
          reason: 'Provide a reason for aborting this labware',
        },
      },
      ignoreTimeConstraints: {
        title: 'Ignore constraints',
        dialogDescription:
          'Review the time constraints below and provide a reason before ignoring them.',
        accordion: {
          reason: 'Provide a reason for ignoring these constraints',
        },
      },
      abortWorkflow: {
        title: 'Abort workflow',
        dialogDescription:
          'The following labware will be aborted as part of terminating this workflow. You will not be able to resume the workflow from this point.',
        description:
          'The following labware will be aborted as part of this workflow. You will not be able to resume the workflow from this point.',
        accordion: {
          reason: 'Provide a reason for aborting this workflow',
        },
      },
      skipTask: {
        title: 'Skip task',
        dialogDescription:
          'Complete the failed task manually and continue to the next task in the workflow.',
        info: {
          title: 'Operator action required',
          description:
            'Complete the failed task manually. Ensure the labware is in the correct location before continuing.',
        },
        accordion: {
          tasks: {
            trigger: 'Task to complete manually',
            table: {
              newLocation: 'New location',
            },
          },
        },
        confirmation:
          'By continuing, you confirm that that the failed task was completed manually and all labware has been repositioned correctly',
        buttons: {
          continue: 'Continue to next task',
        },
      },
      failoverTask: {
        title: 'Use failover device',
        dialogDescription:
          'Run the task on an alternative instrument. The scheduling engine will attempt to find the next best available instrument to run the failed task.',
        instruments: {
          label: 'Available failover instruments',
          help: 'Select which instruments the labware may fail over to. The scheduling engine picks one of the selected instruments.',
          empty: 'No failover instruments available',
        },
        transportMode: {
          label: 'Transport Mode',
          info: 'How the labware will be moved to the failover instrument — automatically by the robot, or manually by an operator.',
          automatic: 'Automatic',
          manual: 'Manual',
          manualInfo: {
            title: 'Operator action required',
            description:
              'You will be prompted to move each labware to the failover instrument manually.',
          },
        },
        residentLabware: {
          label: 'Impacted Labware',
          empty: 'No labware to move off the failed instrument',
          table: {
            batch: 'Batch',
            currentLocation: 'Current Location',
          },
        },
        confirmation:
          'By continuing, you confirm that the failed instrument will be disabled for the rest of the workflow.',
        buttons: {
          continue: 'Continue with failover device',
        },
        failure: {
          description:
            'The scheduling engine could not find an available instrument to run the failed task.',
        },
      },
      retryTask: {
        title: 'Retry task',
        dialogDescription: 'Re-attempt the failed task',
        confirmation:
          'By continuing, you confirm that the impacted labware has been moved back to the starting point of the failed task.',
        info: {
          description:
            'To retry the failed task move the impacted labware back to the starting point of the failed task.',
        },
      },
      pauseTransport: {
        title: 'Pause transport',
        dialogDescription:
          'Pausing will complete the current transport before stopping. Review active tasks and time constraints below.',
        description:
          'Upcoming transport tasks will be suspended after current transport tasks have completed. Other tasks will continue as planned.',
        accordion: {
          currentTransportTask: {
            trigger: 'Current transport task',
          },
          nextTransportTask: {
            trigger: 'Next transport task',
          },
          activeTimeConstraints: {
            trigger: 'Active time constraints',
            table: {
              constraint: 'Constraint',
            },
          },
          reason: 'Provide a reason for pausing transport',
        },
      },
      resumeTransport: {
        title: 'Transport paused',
        dialogDescription:
          'Review pause details and pending tasks before resuming workflow execution.',
        description:
          'Transport has been paused. Other tasks will continue as planned',
        accordion: {
          pauseDetails: {
            trigger: 'Pause details',
          },
        },
      },
      addToQueue: {
        button: {
          disabledTooltip:
            'Resolve validation errors before adding to the queue',
        },
        topbar: {
          nameLabel: 'Plan name',
          stalePlacementTooltip: 'Recalculate to apply your changes',
        },
        batchSize: {
          title: 'Batch size',
          label: 'Number of batches',
        },
        parameters: {
          title: 'Edit parameters',
          description: 'Adjust parameter values for this run',
          empty: 'No parameters required for this workflow',
          invalidTooltip: 'Resolve parameter errors before calculating',
          unparseableSeedHint:
            'The saved value could not be read for this field type. Enter a value to override it, or leave blank to use the default.',
        },
        settings: {
          latestTime: 'Latest time',
          earliestTime: 'Earliest time',
          title: 'Adjust adding settings',
          schedule: {
            label: 'Add to',
            nextAvailable: 'Next available slot',
            timeConstraint: 'Specify time constraints',
          },
          earliestStart: { label: 'Earliest start' },
          latestFinish: { label: 'Latest finish' },
          priority: {
            title: 'Priority',
            low: 'Low',
            high: 'High',
          },
          calculate: {
            cta: 'Calculate placement in queue',
          },
        },
        preview: {
          title: 'Placement in queue',
          empty:
            'Click "Calculate placement in queue" to preview your workflow in the queue',
          loading: {
            body: 'Plans being calculated into the queue can be viewed and accessed from the',
          },
          start: {
            label: 'Est. Start time',
          },
          end: {
            label: 'Est. End time',
          },
          manualTasks: {
            title: 'Est. manual task times',
            empty: 'No manual tasks for this workflow',
          },
          setupTimes: {
            title: 'Est. setup times',
            empty: 'No setup times for this workflow',
          },
          cleanupTimes: {
            title: 'Est. cleanup times',
            empty: 'No cleanup times for this workflow',
          },
          fullQueueDetails: 'Full queue details',
          movedWorkflows: 'Moved workflows:',
          tooltip: 'All moved tasks still fulfill settings and rules applied',
        },
        gxpDescription: 'Confirm add to queue',
        errors: {
          fetchFailed: 'Something went wrong while fetching the queue status',
          deviceGroupNotReady:
            'Set up these devices before adding to queue: {{deviceNames}}',
          presetArchived:
            "{{presetName}} has been archived and can't be added to the queue",
          presetNotSimulated:
            '{{presetName}} must be simulated before being added to the queue',
          presetNotFound:
            'This preset no longer exists. Refresh and try again.',
          unknown: 'Something went wrong adding the preset to the queue',
          parameterInvalid: 'This parameter value is invalid',
          tryAgain: 'Please try adding to queue again.',
        },
        queueCalendar: {
          hourMarker: '{{hours}}h',
          empty: 'No tasks scheduled',
          slider: {
            day: 'Day {{number}}',
            dayRange: 'Day {{start}} - Day {{end}}',
            dayCount_one: '{{count}} day',
            dayCount_other: '{{count}} days',
            showCurrentWorkflow: 'Show current workflow',
            ariaLabel: 'Day range slider',
          },
          badges: {
            development: 'Development',
            productionShort: 'Prod',
            developmentShort: 'Dev',
            moved: 'Moved',
            gap: 'Gap',
            overnight: 'Overnight',
            manualBooking: 'Manual booking',
          },
          legend: {
            currentWorkflow: 'Current workflow',
            scheduledWorkflow: 'Scheduled workflow',
          },
          hover: {
            estStart: 'Est. Start:',
            estEnd: 'Est. End:',
            priority: 'Priority:',
            priorityAriaLabel: 'Job priority level',
            earliestStart: 'Earliest start:',
            latestFinish: 'Latest finish:',
            overnightWorkflow: 'Overnight workflow',
          },
          aria: {
            daySchedule: 'Day {{dayNumber}} schedule',
            job: 'Job {{name}}',
            movedEarlier: 'Moved earlier',
            movedLater: 'Moved later',
            overnightJob: 'Overnight job',
            partOfProcess: 'Part of process',
          },
        },
      },
      progressHeader: {
        controls: {
          resume: 'Resume transport',
          intervene: 'Intervene',
        },
        startTime: 'Start time: {{time}}',
        abortedAt: 'Aborted at {{time}}',
        failedAt: 'Failed at {{time}}',
        metrics: {
          completionEst: 'Completion (est.)',
          samples: 'Samples',
          materials: 'Materials',
        },
      },
    },
    layout: {
      leftPanel: {
        title: 'Workflow details',
        togglePanel: 'Toggle workflow details',
        dateStarted: 'Date started',
        plannedStart: 'Planned start',
        expectedDuration: 'Expected duration',
        completionEst: 'Completion est.',
        completedAt: 'Completed at',
        runId: 'Run ID',
        executionLogsExport: {
          buttonText: 'Execution logs CSV',
          modal: {
            title: 'Export execution logs',
            description: 'Choose which labware data to export.',
            labwareSelection: {
              allLabware: 'All labware in this workflow',
              selectedLabware: 'Selected labware only',
              itemsCount: '{{count}} items',
              selectionRequired: 'Please select at least one labware item',
            },
            exportOptions: {
              label: 'Data to include in export',
              includeTransport: 'Include transport',
              includeTransportDescription:
                'Adds all transport tasks to the log',
              includeExecutionParameters: 'Include execution parameters',
              includeExecutionParametersDescription:
                'Parameter values defined for the workflow execution',
            },
            actions: {
              export: 'Export logs',
            },
            exportError: 'Failed to export execution logs. Please try again.',
          },
        },
        workflowDescription: 'Workflow description',
      },
      rightPanel: {
        batchConsistency: 'Batch consistency',
        batchConsistencyPlaceholder: 'Batch consistency coming soon',
        toggleIntegrityRisks: 'Toggle integrity risks',
        topic: {
          jobReplanning: 'Replanning',
          planUpdated: 'Plan updated',
          workflowCompleted: 'Workflow completed',
          workflowFailed: 'Workflow failed',
          taskFailed: 'Task failed',
          fatalError: 'Fatal error',
          warning: 'Warning',
          taskAutoRetry: 'Auto retry task',
          manualTaskDue: 'Manual action due',
          manualTaskUpcoming: 'Manual action upcoming',
          functionStepCompleted: 'Function step successful',
          timeConstraintBroken: 'Time constraint broken',
          orchestratorAlert: 'Job alert',
          deviceAlert: 'Device alert',
          safetyStateChanged: 'Safety state changed',
          safetyEvent: 'Safety event',
          witnessSignatureRequested: 'Approval required',
          witnessSignaturePending: 'Awaiting witness',
          witnessSignatureCompleted: 'Witness signature completed',
          witnessSignatureRejected: 'Witness signature rejected',
          unknown: 'Unknown event type',
        },
        noEvents: 'No events yet',
        card: {
          when: 'When',
          resolvedTime: 'Resolved time',
        },
      },
      metricsPanel: {
        title: 'Labware: samples',
        setViewToTop: 'Set table view to top',
        setViewToBottom: 'Set table view to bottom',
      },
    },
    parallelWorkflows: {
      title: 'Parallel workflows',
      errorLoading: 'Unable to load parallel workflows',
      summary: {
        instrumentUtilization: 'Instrument utilization',
      },
    },
    workflow: {
      errorLoadingPlan: 'Unable to load workflow plan',
      replanning: {
        abortNotice: {
          title: 'The workflow will be aborted following replanning',
          description:
            'A replan is currently in progress. The abort action will be applied following the replanning.',
        },
        pauseNotice: {
          title: 'The workflow will be paused following replanning',
          description:
            'A replan is currently in progress. The pause action will be applied following the replanning.',
        },
      },
      beacon: {
        error: 'Error: {{taskName}} failed — {{labwareName}}',
        errorNoLabware: 'Error: {{taskName}} failed',
        calculatingNoReason: 'Replanning in progress',
        paused: 'System paused — awaiting operator action',
        currentTask: 'Current task: {{description}}',
        currentTasks: 'Current tasks: {{descriptions}}, + {{count}} more',
        standby: 'Stand-by: next activity in {{duration}}',
        taskFormat: '{{name}} — {{device}} — {{duration}}',
        taskFormatNoTime: '{{name}} — {{device}}',
        taskFormatNoDevice: '{{name}} — {{duration}}',
        currentTasksNoOverflow: 'Current tasks: {{descriptions}}',
        calculatingDetail: {
          overrun: 'Task {{taskName}} overrunning by {{duration}}',
          underrun: 'Task {{taskName}} underrunning by {{duration}}',
          resume: 'Replanning after system was paused',
          conditional:
            'Task {{taskName}} produced an unexpected conditional outcome',
        },
      },
      error: {
        description:
          'An error occurred while displaying the workflow. Please try again.',
        retry: 'Retry',
      },
      devicesView: {
        toggleDevices: 'Toggle devices panel',
        noDeviceGroup: 'No device group assigned to this workflow',
        configuring: 'Configuring',
        manualTasks: 'Manual tasks',
        setupTasks: 'Setup tasks',
        cleanupTasks: 'Cleanup tasks',
        noPendingTasks: 'No pending tasks',
        dueAt: 'Due: {{time}}',
        viewNotification: 'View notification',
        configuringStatus: 'Configuring...',
        actionType: {
          labwareLoading: 'Labware loading',
          functionDeviceCommand: 'Device command (function)',
        },
        labwareTable: {
          location: 'Location',
        },
        combinedAction: {
          viewButton: 'View combined action',
        },
      },
    },
    schedule: {
      tabs: {
        queue: 'Queue',
        operations: 'Operations',
      },
      queue: {
        quickFilter: {
          triggerAriaLabel: 'Quick time filter',
          datePicker: 'Date picker',
          startTimeLabel: 'Start time',
          endTimeLabel: 'End time',
          endBeforeStart: 'End must be after the start',
        },
        card: {
          startEst: 'Start [est.]',
          endEst: 'End [est.]',
          workflowsCompleted: 'Workflows completed',
          workflowsInProgress: 'Workflows in progress',
          batchesCompleted: 'Batches completed',
          batchesInProgress: 'Batches in progress',
          reasonMissing: 'Reason unavailable',
          workflowAborted: 'Workflow aborted',
          processAborted: 'Process aborted',
          workflowRemoved: 'Workflow removed',
          processRemoved: 'Process removed',
          warnings: 'Warnings',
          workflowsCalculating_one:
            '<strong>{{count}}</strong> workflow calculating...',
          workflowsCalculating_other:
            '<strong>{{count}}</strong> workflows calculating...',
          batchesCalculating_one:
            '<strong>{{count}}</strong> batch calculating...',
          batchesCalculating_other:
            '<strong>{{count}}</strong> batches calculating...',
        },
        popover: {
          executionPresetInstanceName: 'Execution preset instance name',
          presetInfo: 'Preset info',
          viewAlert: 'View alert',
          batchNumber: 'Batch #{{number}}',
          workflowNumber: 'Workflow #{{number}}',
          workflowsCount: '{{count}} workflows',
        },
        filters: {
          byItemType: 'By process workflow or workflow',
          itemType: {
            processWorkflow: 'Process workflow',
            workflow: 'Standalone workflow',
          },
          byWorkflowAndProcess: 'By workflows and processes',
          groups: {
            standaloneWorkflows: 'Standalone workflows',
          },
        },
        menuLabel: 'Queue actions',
        removeFromQueue: 'Remove from queue',
        confirmRemoveTitle: 'Remove from queue?',
        confirmRemoveDescription:
          'This will remove "{{jobName}}" from the queue.',
        reasonPlaceholder: 'Reason for removal',
        removeProcess: 'Remove process "{{name}}" from queue',
        removeStep: 'Remove step "{{name}}" from queue',
        removeWorkflow: 'Remove workflow "{{name}}" from queue',
        removeSuccess: 'Removed from queue',
        removeError: 'Failed to remove from queue',
        removeNotReady:
          'Unable to remove from queue. Please try again in a moment.',
      },
      operations: {
        workflowsInProgress: 'Workflows: in progress',
        operatorActions: 'Operator actions',
        noActions: 'No pending actions',
        groups: {
          next30: 'Next 30 mins',
          later: 'Later',
        },
        countdownMinutes: '{{count}} min',
        noWorkflows: 'No workflows in progress',
        noDevices: 'No devices to show',
        risks: 'Risks',
        risksTitle: 'Integrity risks',
        risksInfo:
          'Highlights warnings, errors, unexpected events and batch-consistency variances that may affect the integrity or accuracy of this workflow.',
        environmentalParameters: 'Environmental parameters',
        environmentalParametersMin: 'Min.',
        environmentalParametersMax: 'Max.',
        environmentalParametersNoData: 'No parameters available',
        currentlyUsedBy: 'Currently used by',
        maxCapacity: 'Max capacity',
        expectedUtilization: 'Expected utilization [%]',
        chips: {
          pendingActions: 'Pending actions',
          activeWorkflows: 'Active workflows',
          queuedWorkflows: 'Queued workflows',
          completedWorkflows: 'Completed workflows',
          abortedWorkflows: 'Aborted workflows',
          activeDeviceGroups: 'Active device groups',
        },
      },
      process: {
        errorLoading: 'Unable to load process',
        abortProcess: {
          title: 'Abort process',
          description:
            'Aborting the process will stop all active workflows. This action cannot be undone.',
          reasonLabel: 'Reason for aborting',
          reasonPlaceholder: 'Provide a reason for aborting this process',
          confirm: 'Abort process',
          continue: 'Continue',
          back: 'Back',
          abortSuccess: 'Process abort requested',
          abortError: 'Failed to abort process',
          selectTitle: 'Specify the parts of this process to abort',
          selectDescription:
            'Choose which workflows to abort. Unselected workflows will continue running.',
          selectWorkflowsLabel: 'Select workflows',
          selectWorkflowsPlaceholder: 'Search and select workflows',
          noWorkflowsAvailable: 'No workflows available',
          handlingLabel: 'Select batches and next step',
          noWorkflowsSelected: 'No workflows selected for handling',
          summaryLabel: 'Summary',
          suggested: 'SUGGESTED',
          allBatches: 'All Batches ({{count}})',
          abortCompletely: 'Abort completely',
          cannotBeUndone: 'This action cannot be undone.',
          labwareTitle: 'Define how to handle labware in aborted batches',
          labwareNoticeTitle: 'Labware handling',
          labwareNotice:
            'You will be notified through an operator action when it is safe to handle labware.',
          labwareLoadError: "Couldn't load labware for this workflow.",
          columns: {
            batches: 'Batches to abort',
            nextStep: 'Next step',
            aborting: 'Aborting?',
          },
          status: {
            aborting: 'Aborting',
            cancelled: 'Cancelled',
          },
        },
        workflows: {
          title: 'Workflows [{{count}}]',
          toComplete: 'To complete [{{count}}]',
        },
        labwareTracking: {
          title: 'Labware tracking',
          devicesActive: 'Devices ({{active}}/{{total}} active)',
          allDevices: 'All devices',
          filterHint:
            'Click on devices or groups to filter the Labware table below.',
          columns: {
            barcode: 'Barcode',
            contents: 'Contents',
            timeRemaining: 'Time remaining',
          },
        },
      },
    },
    setupPhase: {
      noInstructions: 'No setup instructions',
      instructionCard: {
        completed: 'Completed {{completedAt}}',
        dueAt: 'Due at {{time}}',
        labware: {
          constraints: 'Constraints',
        },
      },
      constraintBadge: {
        min: 'Min {{duration}}',
        max: 'Max {{duration}}',
      },
    },
  },
  notifications: {
    // Shared panel-level keys
    errors: 'Alerts',
    infoAlerts: 'Info alerts',
    emptyNotifications: 'No notifications to show',

    functionDue: {
      inputsHeading: 'Add/edit inputs for the function',
      startStep: 'Start step',
      skipAction: 'Skip action',
      operatorNotes: 'Operator notes',
    },

    sound: {
      mute: 'Mute notification sounds',
      unmute: 'Unmute notification sounds',
    },
    emptyErrors: 'No errors to show',
    emptyInfoAlerts: 'No info alerts to show',
    viewActionInContext: 'View action in context',

    accordion: {
      impactedWorkflows: 'Impacted workflows',
      noImpactedWorkflows: 'No impacted workflows',
      impactedDevices: 'Impacted devices',
      noImpactedDevices: 'No impacted devices',
      additionalLogs: 'Additional logs',
      noAdditionalLogs: 'No additional logs',
      impactedLabware: 'Impacted labware',
      noImpactedLabware: 'No impacted labware',
    },

    actionCard: {
      due: 'Due',
    },

    actionGroup: {
      dueNow_one: '{{count}} operator action due now',
      dueNow_other: '{{count}} operator actions due now',
    },

    filter: {
      alertStatus: {
        open: 'Open',
      },
      operatorActionType: {
        workflowStep: 'Workflow step',
        processStep: 'Process step',
      },
      scope: {
        thisWorkflow: 'This workflow',
        thisProcess: 'This process',
      },
    },
    sort: {
      tooltip: 'Sort',
      title: 'Sort by',
      resolveBy: 'Resolve by',
      detectedAt: 'Detected at',
      dueTime: 'Due time',
      startBy: 'Start by',
    },

    // Error handling (shared)
    error: {
      description: 'Something went wrong.',
      retry: 'Try again',
      unavailable: 'Notifications unavailable. Click to retry.',
      resolveActionFailed: 'Failed to resolve action. Please try again.',
      acknowledgeFailed: 'Failed to acknowledge. Please try again.',
    },

    // Shared action buttons
    actions: {
      acknowledge: 'Acknowledge',
      markSkipped: 'Mark as skipped',
      markComplete: 'Mark as complete',
      helpDialog: {
        info: 'How these options affect my workflow',
        skip: {
          description:
            'Complete the failed task manually and continue to the next task in the workflow',
        },
        retry: {
          description:
            'Re-attempt the failed task. Impacted labware must be moved back to the starting position of the errored task.',
        },
        abortWorkflow: {
          description:
            'Permanently terminate all ongoing tasks and prevent any remaining tasks from being executed. You will not be able to resume activity from this point.',
        },
      },
    },

    permissions: {
      actOperatorActions:
        "You don't have permission to perform operator actions. Ask your administrator to grant act:operator_actions access",
      witnessSignatures:
        "You don't have permission to witness signatures. Ask your administrator to grant witness:signatures access",
    },

    witness: {
      reviewPrompt:
        'You are required to review and witness the action described below.',
      received: 'Received',
      signatureDetails: 'Action taker signature details',
      signed: 'Signed',
      by: 'By',
      approve: 'Approve action',
      reject: 'Reject action',
      witnessBy: 'Witness by',
      actionType: 'Action type',
      runStarted: 'Run started',
      capturedData: 'Captured data',
      resumeFailed:
        'The witnessed action could not be completed. Please try it again.',
      awaitingWitnessSignature: 'Awaiting witness signature',
      awaitingWitnessBlockedHint:
        'This action is pending a witness signature and will take effect once they sign. Please do not resubmit it.',
      pending: {
        heading: 'Action awaiting witness',
        explanation:
          'Your signature was accepted. A witness must approve this action before it takes effect.',
      },
      completed: {
        heading: 'Action witnessed',
        witnessedBy: 'Witnessed by {{name}}',
        witnessedByUnknown: 'Witnessed by another user',
        approved: 'Approved',
      },
      rejected: {
        heading: 'Action rejected',
        rejectedBy: 'Rejected by {{name}}',
        rejectedByUnknown: 'Rejected by another user',
        reason: 'Reason for rejection',
        rejected: 'Rejected',
      },
    },

    // Classification lookups (used in utils.tsx)
    severity: {
      information: 'Information',
    },
    type: {
      parameterThreshold: 'Parameter threshold',
      deviceState: 'Device state',
      system: 'System',
      safety: 'Safety',
      taskExecution: 'Task execution',
      inventoryConsumable: 'Inventory (consumable)',
      operatorAction: 'Operator action',
      witnessSignature: 'Witness signature',
      scheduling: 'Scheduling',
      notification: 'Notification',
    },

    // Navigation (shared)
    navigation: {
      label: 'Event navigation',
    },

    // === FEATURE-SPECIFIC SECTIONS ===

    // DueActionLayout specific
    dueAction: {
      combinedAction: {
        banner:
          'This is part of a combined action with {{workflows}}. Complete them together.',
      },
      actionStart: 'Start action',
      actionDue: 'Action due',
      completeBy: 'Complete by',
      durationOfTask: 'Duration of task',
      estimatedTime: 'Estimated time',
      deviceGroup: 'Device group',
      fileUpload: {
        chooseFile: 'Choose file',
        noFileUploaded: 'No file uploaded',
        remove: 'Remove attachment',
        invalidFile: 'File must be a CSV',
      },
      dataCapture: {
        min: 'min: {{min}}',
        max: 'max: {{max}}',
        rangeMin: 'Min: {{min}}',
        rangeMax: 'Max: {{max}}',
        validation: {
          minNumber: 'Must be at least {{min}}',
          maxNumber: 'Must be at most {{max}}',
        },
      },
      summary: {
        total: 'Total labware',
        typeCount: '{{type}}: {{count}}',
      },
      table: {
        labwareIcon: 'Labware type icon',
        endLocation: 'End location',
        deviceName: 'Device name',
        currentStatus: 'Current status',
      },
    },

    // FailedTaskLayout specific

    // TaskAutoRetry specific
    taskAutoRetry: {
      title: 'Task auto-retry: {{taskId}}',
      body: 'An error was detected at {{timestamp}} on {{deviceName}} during the task {{taskId}}. The task will auto-retry.',
    },

    // InformationLayout specific (TASK_AUTO_RETRY)
    information: {
      attemptNo: 'Attempt number',
    },

    // SafetyStateLayout specific
    safetyState: {
      emergencyStop: 'Emergency stop',
      alertDetectedAt: 'Alert detected at',
      allDevicesStopped:
        'All safety-controlled robots and devices have stopped.',
      triggerPrefix: 'Trigger:',
      triggerSuffix: 'has been engaged.',
      workflowsPaused:
        'Any running workflows are paused and awaiting operator decision after the safety system has been reset.',
      recoveryTitle: 'To recover from the E-Stop:',
      recoveryStep1Title: 'Physically release the emergency stop',
      recoveryStep1Desc: 'Rotate the E-stop',
      recoveryStep2Title: 'Reset the safety system',
      recoveryStep2Desc: 'Press the reset button on the safety adapter.',
      recoveryFooter:
        'Once the safety system is reset, you can choose to resume or abort the affected workflows.',
      eStopCaption: 'E-Stop Pressed',
      fstopping: {
        heading: 'Functional stop {{name}} has been pressed.',
        description:
          'All activity controlled by the safety system will come to a stop in {{timeUntilStop}}',
        connectedDevicesStopIn: 'Connected devices stop in',
      },
      fstopped: {
        triggerLabel: 'Functional stop',
        safeToApproach:
          'You will be informed of when devices are safe to approach.',
        recoveryTitle: 'To recover from the F-Stop:',
        caption: 'F-Stop Pressed',
      },
      idle: {
        heading: 'Safety system reset, choose how to proceed.',
        eStopReset:
          'The emergency stop {{name}} has been physically reset at {{time}}.',
        fStopReset:
          'The Functional stop {{name}} has been physically reset at {{time}}.',
        idleDescription:
          'Safety-connected robots and devices are currently idle. Choose how to continue with the affected activity.',
        resumeAll: 'Resume all workflows',
        abortAll: 'Abort all workflows',
        eStopCaption: 'E-Stop\ndisengaged',
        fStopCaption: 'Safety system\nreset pressed',
        resumeSuccess: 'All workflows resumed',
        abortSuccess: 'All workflows aborted',
        autoResumeHeading: 'Functional stop reset — workflows resumed',
        autoResumeReset:
          'The Functional stop {{name}} was reset at {{time}}, before any device stopped.',
        autoResumeDescription:
          'No action needed. All running workflows are resuming automatically.',
        resolveError: 'Failed to resolve safety incident',
      },
    },

    // OrchestratorAlertLayout specific
    orchestratorAlert: {
      selectAction: 'Select an action to resolve this alert',
      gxpDescription: 'Alert response: {{action}}',
      actions: {
        abort: 'Abort',
      },
      jobErrors: {
        couldNotStart:
          "The run for {{workflowName}} on {{deviceGroupName}} couldn't start. Try adding it to the queue again — if it keeps failing, contact Automata support.",
        workflowFallback: 'this workflow',
        deviceGroupFallback: 'its device group',
      },
      labHours: {
        applied: 'The operator working hours have been updated.',
        appliedWithIssues_one:
          'The operator working hours have been updated, but {{count}} scheduling constraint could not be satisfied under the new hours.',
        appliedWithIssues_other:
          'The operator working hours have been updated, but {{count}} scheduling constraints could not be satisfied under the new hours.',
      },
    },

    // TimeConstraintLayout specific
    timeConstraint: {
      intro: {
        one: 'A time constraint was broken, which may impact your workflow integrity and the original workflow plan.',
        multiple:
          'Some time constraints were broken, which may impact your workflow integrity and the original workflow plan.',
      },
      reason: {
        execution: {
          one: 'The tasks associated with this constraint did not run within the expected duration.',
          multiple:
            'The tasks associated with each constraint did not run within the expected duration.',
        },
        pause: {
          one: 'The workflow was paused for too long, causing this constraint to be broken.',
          multiple:
            'The workflow was paused for too long, causing these constraints to be broken.',
        },
      },
      table: {
        from: 'From',
        to: 'To',
        startOf: 'Start of {{task}}',
        endOf: 'End of {{task}}',
        exceededBy: 'Exceeded by',
      },
    },
  },
  filterBar: {
    resetFilters: 'Reset filters',
    activeFilters: 'Active filters',
    filter: 'Filter',
    allLabel: 'All',
    clearDateRange: 'Clear date range',
    datePicker: {
      am: 'AM',
      pm: 'PM',
    },
    treeFilter: {
      selectAll: 'Select all',
      deselectAll: 'Deselect all',
    },
    filters: {
      byType: 'By type',
      byStatus: 'By status',
      byTimeWindow: 'By time window',
      byDeviceGroup: 'By device group',
      byWorkflow: 'By workflow',
      byProcess: 'By process',
      failedToFetchDeviceGroups: 'Failed to fetch device groups',
      options: {
        // Status options
        // Time window options
        nextHour: 'Next hour',
        today: 'Today',
        tomorrow: 'Tomorrow',
        thisWeek: 'This week',
        all: 'All',
        customDate: 'Custom date',
      },
    },
  },
  planRequestErrors: {
    retractsMoreThanAvailable_one:
      'This workflow tries to remove {{count}} more item from {{labware_name}} than is available. Reduce the batch count or check your starting labware, then try again.',
    retractsMoreThanAvailable_other:
      'This workflow tries to remove {{count}} more items from {{labware_name}} than are available. Reduce the batch count or check your starting labware, then try again.',
    exceedsCapacity_one:
      'This workflow tries to add {{count}} more item to {{labware_name}} than its capacity of {{capacity}}. Reduce the batch count, then try again.',
    exceedsCapacity_other:
      'This workflow tries to add {{count}} more items to {{labware_name}} than its capacity of {{capacity}}. Reduce the batch count, then try again.',
    capacityViolationsHeader: "This workflow can't be placed:",
    violationRetractLine: 'Remove {{over_by}} too many from {{labware_name}}',
    violationCapacityLine:
      'Add {{over_by}} too many to {{labware_name}} (capacity {{capacity}})',
    capacityViolationsGuidance:
      'Reduce the batch count or check your starting labware, then try again.',
    planningTimedOut:
      "We couldn't calculate your queue placement in time. Please try again.",
    translationFailed:
      "We couldn't prepare this workflow to run. If this keeps happening, check the workflow setup.",
    workflowValidationFailed:
      "We couldn't add this workflow to the queue because of a problem with its setup. Open it in the workflow editor to review, then add it to the queue again.",
    manualTransportHeader:
      'This workflow has labware moves that need to be set up as manual (operator) steps before it can be added to the queue.',
    manualTransportStepOpen: 'Open this workflow in the editor',
    manualTransportStepSetNamed:
      'Set these labware moves to manual (operator) transports: {{labware}}',
    manualTransportStepSet:
      'Set the affected labware moves to manual (operator) transports',
    manualTransportStepReAdd: 'Save, then add to the queue again',
  },
  plan: {
    visualisation: {
      labwareCount: '({{count}} labware)',
      batchCount: '{{count}} batches',
    },
    controlPanel: {
      search: {
        labware: 'Search labware...',
        instrument: 'Search instruments...',
      },
      savedViews: {
        label: 'Saved views',
        saveCurrentSettings: 'Save current view settings',
        deleteView: 'Delete view',
        dialogTitle: 'Save view',
        namePlaceholder: 'View name',
        noSavedViews: 'No saved views',
      },
      view: {
        labware: 'Labware view',
        instrument: 'Instrument view',
      },
      time: {
        relative: 'Relative time',
      },
      toggle: {
        settings: 'Toggle settings',
        results: 'Toggle results',
        viewSettings: 'Toggle view settings',
      },
      viewSettings: {
        timeScale: 'X axis time scale',
        minute: 'Minute',
        hour: 'Hour',
        detailLevel: 'Workflow detail level',
        showTasks: 'Show tasks',
        viewMode: 'View mode',
        otherViewTypes: 'Other view types',
      },
    },
    timeline: {
      durationSeconds: '{{seconds}}s',
      collapseAll: 'Collapse all',
      ariaLabel: 'Workflow timeline chart',
      showMarkers: 'Show markers',
      groupByBatch: 'Group by batch',
      resetZoom: 'Reset to 100%',
      zoomIn: 'Zoom in',
      zoomOut: 'Zoom out',
      setupInstructions: 'Setup instructions',
      cleanupInstructions: 'Cleanup instructions',
      estimatedTime: 'Estimated time: {{time}}s',
      marker: {
        viewMore: 'View more',
      },
    },
    filterPanel: {
      title: 'Filter options',
      batches: {
        title: 'Batches',
        selectAll: 'Select all batches',
        item: 'Batch {{number}}',
      },
      labware: {
        selectAll: 'Select all labware',
      },
      instruments: {
        selectAll: 'Select all instruments',
      },
      clearAll: 'Clear all filters',
    },
    tooltip: {
      type: {
        transport: 'Transport',
      },
      manualInteractionRequired: 'Manual interaction required',
      sharedAcrossWorkflows: 'Shared across {{count}} workflows',
      timeGap: 'Time gap',
      deviation: 'Deviation',
    },
    legend: {
      shared: 'Shared',
    },
    hovercard: {
      retries: 'Retries',
      blockedByReplanning: 'Task not started due to replanning',
      blockedByOverrun: 'Waiting on {{taskName}}',
      previousTaskOverrunning: '{{taskName}} is overrunning',
      overrunInProgress: 'This task has exceeded its planned duration',
    },
    insights: {
      common: {
        minutes: '{{value}}m',
        percentMinutes: '{{percent}}% ({{minutes}} m)',
        gaps: 'gaps',
        start: 'Start',
        end: 'End',
        batch: 'Batch',
      },
      labwareConsistency: {
        varianceLabel: 'Variance [%]',
        minDurationLabel: 'Min. duration [m]',
        maxDurationLabel: 'Max. duration [m]',
        workflowVariations: 'Workflow variations',
        sortByTime: 'Sort by time',
        varianceMinutes: 'Variance',
        relativeStartEnd: 'Relative start & end',
        labwareAffected: 'Labware affected',
      },
      instrumentDeadtime: {
        deadtimeMinutes: '{{minutes}} m',
        details: 'Deadtime details',
        deadtimeLabel: 'Deadtime [m]',
      },
      labwareWaitTime: {
        details: 'Labware wait time details',
        periodsLabel: 'Periods [gaps]',
        totalTimeLabel: 'Total time [m]',
        waitTimeLabel: 'Wait time [m]',
        relativeStartEnd: 'Relative start & end [m]',
        sortLongest: 'longest',
        sortShortest: 'shortest',
      },
      deviceUtilisation: {
        individualTitle: 'Individual device utilisation',
        groupByType: 'group by type',
        showEachDevice: 'each device',
        on: 'On',
      },
      instrumentCapacity: {
        peakCapacitySummary: '{{percent}}% [{{used}}/{{total}} slots]',
        peakStorageCapacity: 'Peak storage capacity',
        instrumentDetails: 'Instrument details',
      },
      timeConstraints: {
        atRiskLabel: 'At risk [constraints]',
        totalDefinedLabel: 'Total [defined]',
        allTimeConstraints: 'All time constraints',
        sortByLeeway: 'Sort by leeway',
        sortHigh: 'high',
        sortLow: 'low',
        relationName: 'Relation name',
        timeConstraintDescription: 'Time constraint description',
        targetDuration: 'Target duration',
        executionPresetsDuration: 'Execution presets duration',
        leewayFromMax: 'Leeway from max duration',
      },
      dependencies: {
        total: 'Total',
        allDependencies: 'All dependencies',
        sortEarliest: 'earliest',
        sortLatest: 'latest',
      },
      toolbar: {
        labwareConsistency: 'Labware consistency',
        deviceUtilisation: 'Device utilisation',
        instrumentCapacity: 'Instrument capacity',
        instrumentDeadtime: 'Instrument deadtime',
        labwareWaitTime: 'Labware wait time',
        timeConstraints: 'Time constraints',
        dependencies: 'Dependencies',
      },
    },
  },
  executionPreset: {
    statusCard: {
      infoLabel: 'Status info',
    },
    settings: {
      toggleBatchingAriaLabel: 'Toggle batching',
      title: 'Execution preset settings',
      parameters: 'Parameters',
      feasibilityStrategy: {
        label: 'Feasibility strategy',
        description:
          'Choose how the planner searches for a feasible plan before optimising. Most workflows work best with no strategy.',
        strategy: {
          consistentBatchRepetition: 'Consistent batch repetition',
          batchGrouping: 'Batch grouping',
        },
        strategyDescription: {
          standard: 'Plan all batches together in a single pass.',
          consistentBatchRepetition:
            'Optimise a baseline of batches, then repeat that schedule for the remaining batches to keep timings consistent.',
          batchGrouping:
            'Plan batches in fixed-size groups to reduce solve time on large batch counts.',
        },
        baselineBatchCount: {
          label: 'Baseline batch count',
          description:
            'Number of batches to optimise before the schedule is repeated.',
        },
        baselineOptimisationTimeSeconds: {
          label: 'Baseline optimisation time',
          description: 'How long to spend optimising the baseline batches.',
        },
        groupBatchCount: {
          label: 'Group batch count',
          description: 'Number of batches planned together in each group.',
        },
        maxLabwareWaitTimeSeconds: {
          label: 'Maximum labware wait time',
          description:
            'The maximum allowable wait time between tasks for a piece of labware.',
        },
      },
      optimisationStrategy: {
        label: 'Optimization strategy',
        description:
          'Choose what the planner should optimize for when simulating this execution preset. Objectives higher in the list take precedence and have a greater impact on the resulting plan.',
        addPriority: 'Add priority',
        empty: {
          title: 'No priorities yet',
          description:
            'Add an objective to tell the planner what to optimise for. Without priorities the planner only looks for a feasible plan.',
        },
        objective: {
          executionDuration: 'Execution duration',
          consistency: 'Consistency',
          slack: 'Slack',
          timingTargets: 'Timing targets',
        },
        objectiveTooltip: {
          executionDuration:
            'Target the total execution duration from start to finish.',
          slack:
            'Maximize scheduling flexibility by increasing time buffers around timing constraints.',
          consistency:
            'Reduce variation in task and wait times across batches to improve consistency.',
          labwareWaitTime:
            'Minimize the time labware spends waiting between tasks.',
          timingTargets:
            'Optimize task timing to meet defined targets within the allowed tolerance.',
        },
        objectiveHelper: {
          executionDuration:
            'Target a total execution duration. The planner will attempt to generate a plan that completes as close to this duration as possible.',
          slack:
            'Maximize the available buffer around timing constraints. Plans with more slack are generally more resilient to delays and execution variability.',
          labwareWaitTime:
            'Minimize the time labware spends waiting between tasks while keeping wait times below the configured maximum.',
          consistency:
            'Optimize for consistent timing across batches by reducing differences in task durations and waiting times.',
        },
        weight: {
          label: 'Weight',
          sameOrBetter: 'Same or better',
          within1Percent: 'Within 1%',
          within5Percent: 'Within 5%',
          within10Percent: 'Within 10%',
        },
        stopAfter: {
          label: 'Stop optimising after (seconds)',
        },
        row: {
          remove: 'Remove priority',
          dragHandle: 'Reorder priority',
        },
      },
      relations: {
        label: 'Relations',
        timeConstraint: 'Time constraint',
        noRelations: 'No relations defined',
      },
      loadBalancing: {
        label: 'Load Balancing',
        searchPlaceholder: 'Search workflow, task,...',
        noResults: 'No matching tasks or instruments',
      },
      allocationRules: {
        label: 'Allocation preferences',
        addPreference: 'Add preference',
        addColumn: 'Add column',
        allLabwareAdded: 'All labware already added',
        empty: {
          title: 'No preferences yet',
          description:
            'Pin labware to a specific column or slot range. Preferences are honoured up to the point where all labware can still be placed.',
        },
        row: {
          remove: 'Remove preference',
          selectLabware: 'Select labware',
          noResults: 'No labware found',
          alreadyAdded: 'Already added',
          selectColumn: 'Select column',
          slotsRange: 'Slots {{start}}–{{end}}',
          slotCount: '{{count}}/{{total}}',
          slotRangeAria: 'Slot range',
        },
      },
      combine: {
        label: 'Setup and cleanup grouping',
      },
      operatorAvailability: {
        label: 'Operator availability',
        description:
          'Select workflows that should be planned within operator working hours. Workflows not selected may be planned outside of this operator working hours constraint.',
        viewWorkingHours: 'View operator working hours',
        setupCleanup:
          'Plan all setup and cleanup operator actions during working hours',
        operatorActionsTooltip: 'Operator actions in workflow',
        workingHours: {
          editButton: 'Edit operator working hours',
        },
      },
    },
  },
  simulation: {
    completed: 'Simulated',
    inProgress: 'Simulating',
    createExecutionPresetUnsavedTooltip: 'Save your changes to create a preset',
    multiPlan: {
      picker: 'Multi-plan strategy picker',
      title: 'OR-Tools multi-plan strategy matrix',
      description:
        'Each checked cell spawns a planner variant. First feasible plan wins; remaining variants are cancelled.',
      rowHeader: 'OR-Tools ↓ \\ Hint →',
      variantsSelected_one: '{{count}} variant selected',
      variantsSelected_other: '{{count}} variants selected',
      run: 'Run multi-plan',
      selectorPlaceholder: 'Select variant…',
      // Sibling of `MultiPlanMatrixButton`'s `No hints` label but on the
      // *display* side; intentionally singular here since the selector
      // describes one variant at a time.
      variantNoHint: 'No hint',
      variantFailed: 'failed',
      variantIssueTitle: 'Issue: no feasible solution found in {{seconds}}s',
      variantIssueTitleGeneric: 'Issue: variant aborted',
      variantNoDetails: 'No further detail reported by the planner.',
    },
    card: {
      moreActions: 'More actions',
      favourite: 'Favourite',
      archive: 'Archive',
      rename: 'Rename',
      renamePrompt: 'New name for simulation',
      renameTitle: 'Rename simulation',
      currentSuffix: '(current)',
      historicSuffix: '(historic)',
    },
    gxpDescription: {
      archive: 'Archive execution preset: {{name}}',
    },
    timelineEmptyState:
      'Click on a simulation card to view details and insights here.',
    // Typed planning-failure copy (SUP-4843). Keyed by the gateway's
    // WorkflowExecutionError __typename. DRAFT wording — refine with product.
    executionError: {
      infeasible: {
        title: 'No workable schedule',
        body: "This workflow can't be scheduled with its current time constraints and instruments. Try relaxing a max-time constraint, freeing or adding an instrument, or reducing the batch count.",
      },
      timeout: {
        title: "Couldn't find a schedule in time",
        body: 'The scheduler ran out of time before finding a workable schedule. Try reducing the batch count or simplifying the workflow.',
      },
      invalidInput: {
        title: "This workflow can't be planned",
        body: 'The workflow is invalid for planning. Check the workflow definition and try again.',
      },
      validation: {
        title: 'Workflow failed validation',
        body: 'Resolve the validation issues flagged on the workflow before simulating.',
      },
      inProgress: {
        title: 'Simulation already in progress',
        body: 'This workflow is already being simulated. It may have been started elsewhere. Wait for it to finish, then try again.',
      },
      generic: {
        title: "Couldn't generate a schedule",
        body: 'Something went wrong while planning. Try simulating again.',
      },
      serviceUnavailable: {
        title: "Couldn't prepare the workflow",
        body: "A required service didn't respond in time. This is usually temporary — try simulating again.",
      },
      labwareDoesNotFit: {
        title: "Labware doesn't fit",
        description:
          'The height of the labware exceeds the height of the slots they would use. Choose a labware with a smaller height. Or a position with a larger slot. Then simulate again.',
        line: 'Needs {{needed}} mm; tallest available slot on {{instrument}} is {{slotMax}} mm',
        lineNoPosition:
          'Needs {{needed}} mm; no available position has a tall enough slot',
        locate: 'Locate {{labware}} in canvas',
      },
      tooManyBatches: {
        title: 'Too many batches',
        body: 'You requested {{requested}} batches, but this workflow supports up to {{maximum}}. Reduce the batch count and simulate again.',
      },
      overlappingSlots: {
        title: 'Overlapping slots',
        description:
          "A device's slot configuration defines overlapping slot ranges, so the system can't work out where to place labware. Fix the device's slot configuration in Studio, then simulate again.",
        lineColumns:
          'Column {{columnA}} (slots {{rangeA}}) and column {{columnB}} (slots {{rangeB}}) overlap',
        line: 'Slots {{rangeA}} and slots {{rangeB}} overlap',
      },
      binSlotIsOutputOnly: {
        title: 'A task tries to pull labware out of a Bin',
        description:
          "Bin slots are output-only — once labware lands in a Bin it can't be used again. The tasks below would reuse labware that ends up in a Bin. Move that labware to a different slot, or reconfigure the slot in Studio, then simulate again.",
        line: '{{task}} pulls {{labware}} from a Bin on {{instrument}} (slot {{slot}})',
        lineTransitive:
          '{{consumerTask}} consumes {{labware}} after {{producerTask}} drops it in a Bin on {{instrument}}',
        anInstrument: 'an instrument',
        anUnnamedTask: 'an unnamed task',
      },
      slotConflict: {
        title: 'Conflicting slot assignments',
        description:
          "Some labware are competing for the same slot at the same time, so the run can't be scheduled. Review the slot assignments and simulate again.",
        line: '{{labwareA}} and {{labwareB}} both need slot {{slot}} on {{instrument}} (during {{task}})',
      },
      timeConstraint: {
        title: "Time constraint can't be met",
        description:
          "A time constraint between two tasks can't be satisfied in any valid schedule. Select the link between the two tasks to adjust its limits, then simulate again.",
        tasks: '{{startTask}} → {{endTask}}',
        lineMax: "Can't keep the gap within the {{seconds}}s maximum",
        lineMin: "Can't reach the {{seconds}}s minimum gap",
        line: "The time constraint between these tasks can't be satisfied",
      },
      maxDeadTime: {
        title: 'Labware would wait too long',
        description:
          "Some labware would sit idle longer than the maximum wait time allows between two steps, so the run can't be scheduled. Increase the maximum labware wait time in the simulation settings, or rework the steps, then simulate again.",
        issueHeader: 'Issue',
        line: 'Would wait longer than {{seconds}}s between {{prevTask}} and {{nextTask}}',
      },
      resourceLock: {
        title: 'An instrument is double-booked',
        description:
          "An instrument can only handle one task at a time. Some steps keep an instrument busy across a window where other steps also need it, so the run can't be scheduled. Move one of the conflicting steps before or after that window, then simulate again.",
        line: 'Needs {{instrument}}, which is in use from {{startTask}} until {{endTask}}',
      },
      finalDestination: {
        title: 'Labware blocks an instrument it finishes on',
        description:
          "Some labware ends the run resting on an instrument, keeping that instrument occupied so other steps that need it can't be scheduled. Give the labware a different final position, or free up the instrument, then simulate again.",
        line: 'Ends on {{instrument}} (slot {{slot}}) after {{finalTask}}, keeping it busy for other steps',
      },
      slotAboveCapacity: {
        title: 'Not enough slots on the device',
        description:
          "A device doesn't have enough slots available. Increase the device's capacity in Studio, or move some of the work to another device, then simulate again.",
        line: "Uses slot {{slot}}, beyond {{device}}'s capacity of {{capacity}}",
        aDevice: 'the device',
      },
      insufficientCapacity: {
        title: 'Not enough slots for this workflow',
        description:
          "This workflow needs more slots on an instrument than it has available at once. Increase the instrument's capacity in Studio, or reduce how much labware runs at the same time, then simulate again.",
        shortfallHeader: 'Shortfall',
        line: 'Needs {{needs}}, has {{has}}',
      },
      labwareSlotMismatch: {
        title: "Labware slots don't line up between steps",
        description:
          "The run can't hold labware in the slots where each step needs it. Try assigning one of the steps to a different device, or increasing the device's capacity in Studio, then simulate again.",
        receives: 'Needs {{labware}} in slot {{slot}}',
        sends: 'Leaves {{labware}} in slot {{slot}}',
        locate: 'Locate {{task}} in canvas',
      },
      parameterValue: {
        title: "Parameter values couldn't be applied",
        description:
          'The values this run would use were rejected, so nothing was scheduled. Review the values under Parameters, then simulate again.',
        unknownField: 'Not a field in this workflow',
      },
    },
    settings: {
      automationProfile: 'Automation profile',
      runSimulation: 'Simulate',
      simulating: 'Simulating...',
      disabledTooltip: 'Resolve workflow issues to enable simulation',
      processDisabledTooltip: 'Resolve issues to enable simulation',
      noPermission:
        "You don't have permission to run simulations. Ask your administrator to grant write:simulation access",
      executionPresetName: 'Execution preset name',
      presetName: 'Preset name',
      simulatedBy: 'Simulated by: {{name}}',
      automationVersion: 'Automation version',
      deviceGroupVersion: 'Device group version',
      processVersion: 'Process version',
    },
    parameters: {
      description: 'These parameters can be edited when adding to queue',
      runScopeDescription:
        'Values apply to this simulation only. They are not saved to the preset or the workflow.',
      taskParameters: 'Task parameters',
      usedIn: 'Used in: {{tasks}}',
      errors: {
        invalidNumber: 'Value must be a valid number',
        mustBeInteger: 'Value must be a whole number',
        belowMinimum: 'Value must be at least {{minimum}}',
        aboveMaximum: 'Value must not exceed {{maximum}}',
        belowMinLength: 'Value must be at least {{minLength}} characters',
        aboveMaxLength: 'Value must not exceed {{maxLength}} characters',
        patternMismatch: 'Value does not match the required format',
        invalidParameter: 'Resolve parameter errors before simulating',
      },
    },
    previewInstructions: {
      button: 'Preview setup and cleanup',
      title: 'Setup and cleanup instructions',
      noInstructions: 'No setup or cleanup instructions have been added.',
      noInstructionsInPhase: 'No instructions in this phase.',
    },
    errors: {
      unexpected: 'An unexpected error occurred during simulation.',
      versionPreviewFailed:
        'Could not load that version. Returning to the current view.',
      noActiveAutomation:
        'No active automation found. Please set an active automation to run a simulation.',
    },
  },
  conditionalProperties: {
    conditions: 'Conditions',
    conditionName: 'Condition name',
    deleteCondition: 'Delete condition',
    addElseIfCondition: 'Add ElseIf condition',
    tabs: {
      details: 'Conditional details',
      automation: 'Conditional automation',
    },
  },
  conditionalAutomation: {
    sourceValue: 'Source value',
    operator: 'Operator',
    targetValue: 'Target value',
    operators: {
      equals: 'equals',
      notEquals: 'not equals',
      lessThan: 'less than',
      greaterThan: 'greater than',
      lessThanOrEqual: 'less than or equal',
      greaterThanOrEqual: 'greater than or equal',
    },
  },
  workflowVersioning: {
    permissions: {
      archiveAutomation:
        "You don't have permission to delete automations. Ask your administrator to grant archive:automation access",
    },
    history: {
      title: 'Version history: {{name}}',
      notSaved:
        'Automation not yet saved. Save the workflow to create the first revision.',
      noRevisions: 'No revisions found',
    },
    revisionCard: {
      revision: 'Revision {{number}}',
      definitionRevision: 'Definition revision {{number}}',
      basedOnRevision: 'Based on revision {{number}}',
    },
    preview: {
      title: 'Previewing revision {{number}}',
      from: ' from {{date}}',
      exit: 'Exit preview',
      executionPresetBanner: {
        title: 'Previewing automation version {{automationVersion}}',
        presetVersion: 'Viewing preset version {{version}}',
        presetVersionNamed:
          'Viewing version {{version}} of execution preset "{{name}}"',
        presetVersionRevisions:
          'based on automation v{{automationRevision}} and workflow v{{definitionRevision}}',
        presetVersionProcessRevision:
          'simulated against process revision {{processRevision}}',
        createdAt: 'Created on {{date}}',
        associatedPreset: 'Associated with execution preset: {{name}}',
        restore: 'Restore this version to edit',
      },
      loadFailed: "Couldn't load that version. Please try again.",
    },
    restoreVersionDialog: {
      title: 'Restore automation version {{automationVersion}} to edit?',
      versionDetails: 'Automation version {{automationVersion}} from {{date}}.',
      deselectNote:
        'Currently selected execution preset will be deselected when you restore.',
      error: 'Failed to restore version. Please try again.',
      analysisError:
        'Could not check this version for device compatibility. Restoring may leave automations referencing devices that no longer exist.',
    },
    revert: {
      title: 'Revert to revision {{number}}?',
      description:
        'This will create a new revision with the content from Revision {{number}}. Your current draft will be preserved in history.',
      checkingChanges: 'Checking instrument group changes...',
      deviceChanges: 'Instrument group device changes',
      deviceChangesDescription:
        'The instrument group has changed since this revision. Review the device changes for each affected automation.',
      reverting: 'Reverting...',
      confirm: 'Revert',
      devicesAddedNoBreaking_one:
        '{{count}} device added, no breaking changes.',
      devicesAddedNoBreaking_other:
        '{{count}} devices added, no breaking changes.',
      noDeviceChanges: 'No device changes detected.',
    },
    upgrade: {
      title: 'Upgrade instrument group',
      description: 'Review the device changes before upgrading.',
      safeWithAdditions_one:
        '{{count}} device added, no breaking changes. Safe to upgrade.',
      safeWithAdditions_other:
        '{{count}} devices added, no breaking changes. Safe to upgrade.',
      safeNoChanges: 'No device changes detected. Safe to upgrade.',
      updatedDevices_one: '{{count}} device updated to a new version.',
      updatedDevices_other: '{{count}} devices updated to a new version.',
      removedNotAffected_one:
        '{{count}} device removed but no workflow items are affected.',
      removedNotAffected_other:
        '{{count}} devices removed but no workflow items are affected.',
      applying: 'Applying...',
      apply: 'Apply upgrade',
    },
    revisionUpdate: {
      missingGroup: 'Instrument group not found for this automation',
      revisionMismatch:
        'Instrument group has been updated (revision {{current}} \u2192 {{active}})',
      updateAutomation: 'Update automation',
    },
    deviceImpact: {
      added: 'Added ({{count}})',
      removed: 'Removed ({{count}})',
      affectedItems: 'Affected items:',
      resolution: 'Resolution:',
      selectResolution: 'Select resolution...',
      clearAssignment: 'Clear assignment',
      noAffectedItems: 'No workflow items reference this device.',
    },
    automationCard: {
      upgradeTooltip:
        'Instrument group devices changed \u2014 click to upgrade',
    },
    lifecycle: {
      versionName: 'Version name',
      versionNamePlaceholder: 'e.g., v1.0, stable, release-2024',
      versionNameDuplicate:
        'A {{stage}} version named "{{name}}" already exists',
      confirmTest: {
        title: 'Mark revision {{number}} as Test?',
        description:
          'This will tag revision {{number}} as a Test version for validation.',
      },
      confirmProduction: {
        title: 'Promote revision {{number}} to Production?',
        description:
          'This will tag revision {{number}} as Production, indicating it is SOP-ready.',
      },
      confirmRemoveTag: {
        description:
          'This will remove the {{stage}} tag "{{name}}" from revision {{number}}.',
      },
      badges: {
        draft: 'Draft',
      },
      errors: {
        updateStageFailed: 'Failed to update plan stage',
      },
      dialog: {
        planDetails: 'Plan details',
        workflow: 'Workflow:',
        automation: 'Automation:',
        simulation: 'Simulation:',
        deviceGroup: 'Device group:',
        parametersEditableAtExecution: 'Parameters editable at execution',
        promotionHistory: 'Promotion history',
        descriptionOptional: 'Description (optional)',
        descriptionPlaceholder: 'Add notes about this version...',
      },
    },
  },
  processCanvas: {
    debugDialog: {
      triggerTooltip: 'Debug process data',
      title: 'Process debug data',
    },
    loadError: 'Failed to load process',
    save: {
      failure: 'Failed to save current changes',
    },
    versioning: {
      restoreDialog: {
        title: 'Restore revision {{number}} to edit?',
        description:
          'Restoring will create a new version that can be edited. Your current draft will be preserved in history.',
        confirm: 'Restore',
      },
      restorePresetVersionDialog: {
        title: 'Restore preset version {{version}}?',
        description:
          'Restoring creates a new version from the selected version. Previous versions stay in history; unsimulated changes to the current set-up are replaced.',
      },
      history: {
        notSaved:
          'Automation not yet saved. Save the process to create the first revision.',
      },
    },
    panelHeader: {
      executionPresets: 'Execution presets',
    },
    steps: {
      code: 'Execute code',
    },
    permissions: {
      createSimulationProduction:
        "You don't have permission to add to queue. Ask your administrator to grant create:simulation:production access.",
    },
    addToQueue: {
      title: 'Add to queue',
      disabledTooltip: 'Run a simulation first',
      confirm: 'Continue',
      confirming: 'Confirming...',
      errors: {
        save: 'Failed to save process',
        addToPlan: 'Failed to add process to plan',
        calculate: 'Failed to calculate placement',
        fetchFailed: 'Error fetching queue status',
        confirm: 'Failed to confirm',
        planFailed: 'Planning failed',
      },
    },
  },
  manualStepProperties: {
    tabs: {
      automation: 'Manual automation',
      details: 'Manual details',
    },
    descriptionPlaceholder: 'Enter task description...',
    connectedLabware: 'Connected labware',
    notExecutableNotice:
      'Manual steps are not executed at runtime yet. Simulating or running a process that contains one will fail.',
    taskDefinition: 'Task definition',
    taskDefinitionPlaceholder:
      'Describe the task the operator should perform...',
    pauseType: 'Pause type',
    pauseOptions: {
      none: 'No pause',
      process: 'Pause process',
      batch: 'Pause batch',
    },
    estimatedDuration: 'Estimated duration (seconds)',
    associations: 'Task associations',
    associateInstrument: 'Associate with instrument',
    associateLabware: 'Associate with labware',
    selectInstrument: 'Select an instrument',
    selectLabware: 'Select connected labware',
    noConnectedLabware: 'Connect labware to this step to associate it.',
  },
  workflowStepProperties: {
    tabs: {
      automation: 'Workflow automation',
      details: 'Workflow details',
    },
    mapLabware: 'Map connected labware',
    noMappings: 'Connect labware or add from workflow to create mappings.',
    selectLabware: 'Select labware',
    unconnected: 'Unconnected',
    deleteMapping: 'Delete mapping',
    additionalLabware: 'Additional labware',
    allLabwareMapped: 'All workflow labware has been mapped.',
    automation: 'Automation',
    selectAutomation: 'Select an automation',
    plan: 'Execution preset',
    selectPlan: 'Select an execution preset',
    noPlans: 'No execution presets available for this automation.',
    parameters: 'Parameters',
    noParameters: 'No parameters in this execution preset.',
    parametersReadOnly:
      'Parameter editing is not available in this environment. These are the values from the execution preset.',
    selectWorkflowFirst: 'Select a workflow first',
    parametersLoadError: 'Could not load parameters for this execution preset.',
    parameterErrors: {
      required: 'This parameter needs a value',
    },
  },
  processSimulation: {
    createExecutionProfile: 'Create execution profile',
    backToProcess: 'Back to process',
  },
  labSettings: {
    stageChanges: 'Stage changes',
    saveError: 'Could not save changes. Please try again.',
    preview: {
      changed: 'Lab operating hours have changed: see changes in queue here',
      button: 'Preview',
      calculating: 'Calculating preview',
      failed: 'Preview failed to calculate. Try again.',
      currentQueue: 'Current queue',
      impacted_one: '{{count}} process/workflow impacted by change.',
      impacted_other: '{{count}} processes/workflows impacted by change.',
      inProgressSafe: 'Current in-progress activity is not impacted.',
      scheduledCaveat:
        "This change is scheduled for {{date}} and won't affect the current queue until then. The calendar below previews its effect as if it applied today — the actual impact is recalculated when it takes effect.",
      noConstraints: 'No broken time constraints.',
      allConstraints: 'All time constraints',
      brokenConstraints: 'Broken constraints',
      totalConstraints: 'Total time constraints',
      timeConstraints: 'Time constraints',
      otherConstraints: 'Other broken constraints',
      confirmBlockedOther:
        "Can't apply while other constraints are broken. Resolve them first.",
      allWorkflows: 'All workflows',
      collapseConstraints: 'Collapse constraints',
      hourly: 'Hourly',
      daily: 'Daily',
      showReplanning: 'Show replanning changes',
      back: 'Back (close this screen)',
      revert: 'Revert changes',
      confirm: 'Confirm',
      applyFailed: "Couldn't apply the lab-hours change",
      dayLabel: 'Day {{index}}',
      step: {
        setup: 'Setup',
        main: 'Main',
        cleanup: 'Cleanup',
        manual: 'Manual',
        job: 'Job',
      },
      kind: {
        process: 'Process',
        workflow: 'Workflow',
      },
      legend: {
        title: 'Schedule changes',
        unchanged: 'Unchanged',
        sameDay: 'Moved (same day)',
        crossDay: 'Moved to another day',
      },
      hiddenJobs: 'Also on this day',
    },
    operatorWorkingHours: {
      title: 'Operator working hours',
      description:
        'Set the working hours for your lab operators. This will help determine when manual operator actions can take place.',
      effectiveFrom: 'Changes effective from',
      immediately: 'Immediately',
      deleteTimeRange: {
        title: 'Delete time range',
        description:
          'Are you sure you want to delete this time range? This action cannot be undone.',
      },
      days: {
        monday: 'Monday',
        tuesday: 'Tuesday',
        wednesday: 'Wednesday',
        thursday: 'Thursday',
        friday: 'Friday',
        saturday: 'Saturday',
        sunday: 'Sunday',
      },
      searchTime: 'Search time...',
      noTimeFound: 'No time found.',
      open247:
        'Your lab currently operates 24/7. No working-hour restrictions are applied.',
      setHours: 'Set working hours',
      scheduledChange: 'A working-hours change is scheduled for {{date}}.',
      allDay: 'All day',
      closedWarning:
        'Every day is turned off, so the lab will be closed all week. Turn on a day to set operating hours. Workflows added to the queue will still be planned, but flagged as scheduled outside operating hours.',
    },
    labDowntime: {
      title: 'Lab downtime',
      description: 'Set downtime time windows for your lab.',
      deleteDowntime: {
        title: 'Delete downtime',
        description:
          'Are you sure you want to delete this downtime entry? This action cannot be undone.',
      },
      selectDate: 'Select date',
      repeat: {
        doesNotRepeat: 'Does not repeat',
        daily: 'Daily',
        weekly: 'Weekly on {{day}}',
        monthly: 'Monthly on {{dayOrdinal}}',
        annually: 'Annually on {{date}}',
        everyWeekday: 'Every weekday',
      },
    },
    summary: {
      closed: 'Closed',
      labClosed: 'Lab closed all week',
      unrestricted: 'Operates 24/7 — no working-hour restrictions',
      noDowntime: 'No downtime scheduled',
      changeWorkingHours: 'Change operator working hours',
      changeDowntime: 'Change lab downtime',
      // A time range; the separator lives here so a locale can change it if a hyphen doesn't fit.
      timeRange: '{{from}}-{{to}}',
      moreSlots: '+{{count}} more',
      showLess: 'Show less',
    },
  },
  settings: {
    pagination: {
      previous: 'Previous',
      next: 'Next',
      pageOf: 'Page {{current}} of {{total}}',
    },
    auditExports: {
      title: 'Data export settings',
      description:
        'Configure where audit data is exported for long-term storage and compliance.',
      loadFailure: 'Failed to load export settings',
      destination: {
        title: 'Destination',
        emptyTitle: 'No export destination',
        emptyDescription:
          'Add a destination to automatically export audit data to your external system.',
        add: 'Add destination',
        providerSharepoint: 'SharePoint',
        driveId: 'Drive ID',
        statusInactive: 'Inactive',
        unnamed: 'Untitled destination',
      },
      schedule: {
        title: 'Export schedule',
        frequency: 'Frequency',
        dayOfWeek: 'Day',
        time: 'Time',
        timezone: 'Timezone',
        nextRun: 'Next scheduled export',
        frequencyHourly: 'Hourly',
        frequencyWeekly: 'Weekly',
        empty:
          'No schedule set. Exports are not delivered until a schedule is configured.',
        editAria: 'Edit schedule',
        editTitle: 'Edit export schedule',
        editDescription:
          'Choose how often audit data is delivered to the destination.',
        dayPlaceholder: 'Select a day',
        clear: 'Clear schedule',
        saveFailure: 'Failed to save the schedule',
      },
      dialog: {
        createTitle: 'Add export destination',
        editTitle: 'Edit export destination',
        description: 'Audit data will be exported to this SharePoint location.',
        namePlaceholder: 'Lab SharePoint',
        siteUrl: 'Site URL',
        siteUrlPlaceholder: 'https://contoso.sharepoint.com/sites/lab',
        tenantId: 'Tenant ID',
        clientId: 'Client ID',
        clientSecret: 'Client secret',
        destinationPath: 'Destination path',
        destinationPathPlaceholder: '/Audit exports',
        enabled: 'Export active',
        secretEditHint: 'Re-enter the client secret to test and save changes',
        test: 'Test connection',
        testing: 'Testing connection…',
        testSuccess: 'Connection successful',
        testSuccessWithDrive: 'Connection successful — drive {{driveId}}',
        testRequired: 'Test the connection before saving',
        saveFailure: 'Failed to save the destination',
      },
      testReason: {
        authFailed:
          'Authentication failed. Check the tenant ID, client ID and secret.',
        siteNotFound: 'SharePoint site not found. Check the site URL.',
        forbidden:
          'Access denied. The app registration lacks permission for this site.',
        destinationNotWritable:
          'The destination path is not writable. Check the path and permissions.',
        networkError:
          'Could not reach SharePoint. Check connectivity and try again.',
        unknown: 'Connection test failed. Check the details and try again.',
      },
    },
    users: {
      table: {
        userName: 'User name',
        roleTypes: 'Role types',
        lastLogin: 'Last login',
      },
      status: {
        active: 'Active',
        deactivated: 'Deactivated',
        invited: 'Invited',
      },
      roleType: {
        system: 'System',
        custom: 'Custom',
      },
      actions: {
        deactivate: 'Deactivate',
        activate: 'Activate',
        resetPin: 'Reset PIN',
        unlockPin: 'Unlock PIN',
        readOnly: '{{userName}} cannot be modified',
      },
      pagination: {
        showingResults: 'Showing {{start}}-{{end}} of {{total}} users',
      },
      emptyState: {
        title: 'No users yet',
        description:
          'Users will appear here once they are invited to the system.',
        noResults: 'No users found',
        noResultsDescription:
          'No users match the current filters. Try adjusting your search or filters.',
      },
      loading: 'Loading users...',
      error: 'Failed to load users.',
      aria: {
        moreActions: 'More actions for {{userName}}',
      },
      filters: {
        byRole: 'By role',
        byRoleType: 'By role type',
        searchPlaceholder: 'Search users',
      },
      neverLoggedIn: 'Never',
      editDialog: {
        title: 'Edit user',
        description: 'Update user information.',
        fullName: 'Full name',
        emailAddress: 'Email address',
        roles: 'Role',
        rolesPlaceholder: 'Select a role...',
        adminNotes: 'Admin notes',
        adminNotesPlaceholder:
          "Add notes about this user's access or any relevant information.",
        adminNotesDescription:
          'Optional notes for administrative tracking and user management.',
        updateFailure: 'Failed to update user. Please try again.',
        roleUpdateFailure:
          'User details were saved, but the role change failed. Please try again.',
        userNotFound: 'Unable to load user. Please try again.',
      },
      createDialog: {
        title: 'Add user',
        description: 'Add a new user to the system and assign their role..',
        sourcePlaceholder: 'Select a source...',
        failure: 'Failed to create user. Please try again.',
      },
      deactivateDialog: {
        title: 'Deactivate user',
        description:
          'This will remove all access permissions for the following user:',
      },
      resetPinDialog: {
        description:
          'This will reset the PIN for the following user. They will need to set a new PIN before they can provide an e-signature.',
        reasonLabel: 'Reason',
        reasonPlaceholder: 'Why are you resetting this user’s PIN?',
        reasonRequired:
          'Please provide a reason for resetting this user’s PIN.',
        failure: 'Failed to reset PIN. Please try again.',
      },
      unlockPinDialog: {
        description:
          'This will unlock the PIN for the following user, allowing them to provide their e-signature again.',
        failure: 'Failed to unlock PIN. Please try again.',
      },
    },
    navigation: 'Settings navigation',
    tabs: {
      users: 'Users',
      roles: 'Roles',
    },
    compliance: {
      title: 'Compliance',
      table: {
        signaturePolicyCategory: 'Signature policy category',
        requirement: 'Requirement',
        lastUpdated: 'Last updated',
      },
      requirement: {
        single: 'Single signature',
        dual: 'Dual signature',
      },
      loading: 'Loading signature policies...',
      error: 'Failed to load signature policies.',
      emptyState: {
        title: 'No signature policies found',
        description: 'Signature policies will appear here once configured.',
      },
      aria: {
        moreActions: 'More actions for {{policyName}}',
      },
      editDialog: {
        title: 'Edit signature policy',
        description: 'Update the signature requirement for {{policyName}}.',
        saving: 'Saving...',
        updateFailure: 'Failed to update signature policy. Please try again.',
        gxpDescription:
          'Update signature policy: {{policyName}} from {{oldRequirement}} to {{newRequirement}}',
        gxpDescriptionRoles:
          'Update witness roles for signature policy: {{policyName}}',
        witnessRolesLabel: 'Witness roles',
        witnessRolesHint:
          'Leave empty to allow any authorised witness to sign.',
      },
    },
    roles: {
      title: 'Role management',
      systemRoles: 'System roles',
      systemRole: 'System role',
      permissionScopes: 'Permission scopes: {{count}}',
      loading: 'Loading roles...',
      error: 'Failed to load roles.',
      emptyState: {
        title: 'No roles found',
        description: 'System roles will appear here.',
      },
    },
    secrets: {
      loading: 'Loading secrets...',
      error: 'Failed to load secrets.',
      emptyState: {
        title: 'No secrets yet',
        description:
          'Secrets let you store private values like passwords, tokens, and API keys so you can reuse them safely across workflows, processes and device settings.',
        addFirst: 'Add your first secret',
      },
      table: {
        secretName: 'Secret name',
        lastEdited: 'Last edited',
      },
      createDialog: {
        title: 'Add secret',
        description: 'Add a new secret to store a private value securely.',
        secretNamePlaceholder: 'e.g. API_KEY',
        failure: 'Failed to create secret. Please try again.',
        gxpDescription: 'Create secret: {{secretName}}',
      },
      editDialog: {
        title: 'Edit secret',
        description: 'Update the values for {{secretName}}.',
        newValueHint: 'Enter a new value to update',
        submit: 'Save changes',
        failure: 'Failed to update secret. Please try again.',
        gxpDescription: 'Update secret: {{secretName}}',
      },
      deleteDialog: {
        title: 'Delete secret',
        description:
          'Are you sure you want to delete the secret "{{secretName}}"? This action cannot be undone.',
        failure: 'Failed to delete secret. Please try again.',
        gxpDescription: 'Delete secret: {{secretName}}',
      },
      access: {
        title: 'Secret access',
        tooltipLabel: 'Secret access information',
        tooltipBefore:
          'Access to secrets depends on user roles. Roles are managed in',
        tooltipBold: 'Settings \u2192 User Management',
        tooltipAfter: 'and apply to all secrets.',
        viewOnly: 'View only:',
        edit: 'Edit:',
      },
      aria: {
        moreActions: 'More actions for {{secretName}}',
        toggleVisibility: 'Toggle value visibility',
      },
    },
  },

  gxp: {
    role: {
      author: 'Author',
      witness: 'Witness',
    },
  },

  gxpSignatureDialog: {
    title: 'Electronic signature required',
    description:
      'Your electronic signature, including your name, date/time, and the meaning of your signature, will become part of this record in the user log.',
    signingAs: 'You are signing as:',
    attestation:
      'I attest that I performed this action and that the information recorded is complete and accurate.',
    reasonForSignature: 'Reason for signature',
    guidance: 'Guidance',
    authenticateSignature: 'Authenticate your signature',
    sign: 'Sign',
    rejectTitle: 'Reject this action',
    rejectDescription:
      'Provide a reason and authenticate to reject this action. The action taker will be notified so they can correct and re-submit it.',
    rejectReasonLabel: 'Rejection reason',
    rejectReasonPlaceholder: 'Explain why this action is being rejected',
    reject: 'Confirm rejection',
    error: {
      failed:
        'Signature failed. Please verify your PIN is correct and try again.',
    },
    secondSignaturePending: {
      title: 'Second signature pending',
      body: 'Please wait for the second signature to be completed. We will notify you when this is complete.',
    },
  },

  createPinDialog: {
    title: 'Create your e-signature PIN',
    description:
      'A secure PIN is required to electronically sign actions in a GxP environment.',
    descriptionDetail:
      "You'll be asked for it whenever you author, approve, or witness an action that creates, modifies, or deletes a record.",
    originalPin: 'Enter your current PIN',
    enterPin: 'Enter a secure PIN between 6 and 8 digits',
    newPin: 'Enter a new PIN between 6 and 8 digits',
    confirmPin: 'Confirm your PIN',
    savePin: 'Save PIN',
    error: {
      mismatch: 'PINs do not match. Please try again.',
      tooShort: 'PIN must be at least 6 digits.',
      confirmTooShort: 'Please confirm your PIN.',
      originalTooShort: 'Please enter your current PIN.',
      originalPinIncorrect:
        'The current PIN you entered is incorrect. Please try again.',
      failed: 'Failed to save PIN. Please try again.',
    },
    update: {
      title: 'Update your e-signature PIN',
      submit: 'Update PIN',
    },
    success: {
      title: 'PIN created successfully',
      description:
        'You have successfully created your e-signature PIN. You can change your PIN later in your account settings.',
    },
    updateSuccess: {
      title: 'PIN updated successfully',
      description:
        'You have successfully updated your e-signature PIN. You can change your PIN later in your account settings.',
    },
  },
  secretPicker: {
    selectSecret: 'Use secret value',
    searchPlaceholder: 'Search secrets',
    newSecret: 'New secret',
    noResults: 'No secrets found',
    clearSecret: 'Clear secret reference',
    secretKeyTooltip: 'Value is resolved from a secret',
  },

  executionLogs: {
    navTitle: 'Logs',
    title: 'Execution logs',
    analysis: 'Analysis',
    search: 'Search executions',
    infoBanner:
      'Audit data is retained in LINQ for 30 days. To ensure long-term storage and compliance, data is exported to your external system.',
    viewSettings: 'View settings',
    noRecords: 'No execution records found',
    loadFailure: 'Failed to load execution records',
    recordCount_one: '{{count}} execution record',
    recordCount_other: '{{count}} execution records',

    table: {
      executionName: 'Execution name',
      executionId: 'Execution ID',
      actualStartTime: 'Start time',
      actualCompletionTime: 'Completion time',
      initiator: 'Initiator',
    },

    status: {
      inProgress: 'In progress',
    },

    filter: {
      label: 'Filters',
      timeWindow: {
        thisWeek: 'This week',
        thisMonth: 'This month',
      },
      apply: 'Apply filters',
    },

    pagination: {
      previousPage: 'Previous page',
      nextPage: 'Next page',
    },

    detail: {
      loadFailure: 'Failed to load execution details',
      notFound: 'Execution not found',
      viewExecution: 'View execution',
      export: {
        label: 'Export',
        unexpectedResponseError:
          'Received an unexpected response format. Please try again.',
      },

      exportMenu: {
        bundle: 'Export execution log bundle (all files)',
        summary: 'Execution summary',
        history: 'Execution history',
        signatureRecords: 'Signature records',
        artefacts: 'Artefacts',
      },

      executionDetails: 'Execution details',
      recordId: 'Record ID: {{id}}',
      automation: 'Automation',

      timeline: 'Timeline',
      started: 'Started',
      duration: 'Duration:',
      planned: 'Planned:',
      actual: 'Actual:',

      replans: 'Replans',
      replansImpact: 'Impact on workflow completion time',
      noReplansRecorded: 'No replans recorded',

      executionParameters: 'Execution parameters',
      noExecutionParameters: 'No parameters recorded',

      integrityRisks: 'Integrity risks ({{count}})',
      noIntegrityRisks: 'No integrity risks detected',
      integrityRiskOccurredAt: 'Occurred at',
      integrityRiskSlack: 'Slack time',

      devices: 'Devices ({{count}})',
      noDevices: 'No devices recorded',
      firmwareVersion: 'Firmware version',
      serialNumber: 'Serial number',
      globalConfig: 'Global config',
      notAvailable: 'Not available',

      userActions: 'User actions ({{count}})',
      noUserActions: 'No user actions recorded',
      userActionUser: 'User',
      userActionTimestamp: 'Time stamp',
      // v1 default badge labels per user-action event type (Design to refine
      // copy + colours). Keyed by the AuditStepEventType value.
      userActionType: {
        EXECUTION_QUEUED: 'Initiate',
        USER_RESUME: 'Resume',
        USER_REROUTE: 'Reroute',
        USER_FAILOVER_TASK: 'Failover task',
        USER_CONTINUE_TASK: 'Continue task',
        USER_ABORT_LABWARE: 'Abort labware',
        USER_RESOLVE_MANUAL_ACTION: 'Resolve manual action',
        USER_CANCEL_STEP: 'Cancel step',
        USER_CANCEL_PROCESS: 'Cancel process',
      },
    },

    artefactDownloadDialog: {
      title: 'Download artefacts',
      description:
        'Select tasks whose artefacts you want to include in the ZIP download.',
      noTasks: 'This run has no audit-trail tasks to download.',
      batchCount_one: '({{count}} batch)',
      batchCount_other: '({{count}} batches)',
      download: 'Download',
      loadFailure: 'Failed to load tasks for this run.',
      downloadError: 'Failed to download artefacts. Please try again.',
      unexpectedResponseError: 'Unexpected server response',
    },
  },
  userLogs: {
    title: 'User logs',
    missingValue: '—',
    retry: 'Retry',
    export: {
      label: 'Export user logs',
      unavailable: 'User log export is not available yet.',
    },
    actionType: {
      modify: 'Modify',
      initiate: 'Initiate',
      intervene: 'Intervene',
      alertResponse: 'Alert response',
      upload: 'Upload',
      export: 'Export',
      access: 'Access',
      approve: 'Approve',
      review: 'Review',
      reject: 'Reject',
    },
    table: {
      timestamp: 'Timestamp',
      actionType: 'Action type',
      recordId: 'Record ID',
      actionPerformed: 'Action performed',
      user: 'User',
    },
    list: {
      loading: 'Loading User logs',
      empty: 'No User logs are available.',
      filteredEmpty: 'No User logs match these filters.',
      failure: 'User logs could not be loaded.',
    },
    pagination: {
      loading: 'Loading more User logs',
      failure: 'More User logs could not be loaded.',
    },
    filters: {
      allActionTypes: 'All action types',
      noActionTypes: 'No action types found.',
      dateRange: 'Date range',
      clearDate: 'Clear date',
      search: 'Search User logs',
    },
    detail: {
      title: 'User log detail',
      regionLabel: 'Selected User log',
      close: 'Close User log detail',
      loading: 'Loading User log detail',
      notFound: 'User log not found or no longer available.',
      failure: 'User log detail could not be loaded.',
      integrityFailure:
        'Stored evidence failed integrity validation and cannot be displayed.',
      none: 'None',
      copyEvidence: 'Copy evidence',
      sections: {
        actionInformation: 'Action information',
        changeEvidence: 'Change evidence',
        affectedRecord: 'Affected record',
        userInformation: 'User information',
        reason: 'Reason',
        impactedResources: 'Impacted resources',
        executionLog: 'Execution log',
        signatureInformation: 'Signature information',
      },
      fields: {
        timestamp: 'Date and time',
        timezone: 'Timezone',
        outcome: 'Outcome',
        evidenceKind: 'Kind',
        evidenceVersion: 'Version',
        evidencePayload: 'Evidence payload',
        recordLabel: 'Label',
        recordType: 'Record type',
        affectedRecordId: 'Affected-record ID',
        userId: 'User ID',
        email: 'Email',
        authenticated: 'Authenticated',
        roles: 'Roles',
        resourceType: 'Resource type',
        resourceId: 'Resource ID',
        resourceLabel: 'Resource label',
        signatureRequirement: 'Requirement',
      },
      outcome: {
        succeeded: 'Succeeded',
      },
      recordType: {
        executionPreset: 'Execution preset',
      },
      evidenceKind: {
        inlineDiff: 'Inline diff',
      },
    },
  },
  buildAgent: {
    errorFallback: {
      title: 'EVA is unavailable',
      description:
        'The assistant hit an unexpected error and was isolated so the rest of LINQ keeps working. Try again.',
      reload: 'Reload EVA',
    },
    workflowBubble: {
      openInCanvas: 'Open in canvas',
    },
    toolDetail: {
      noDetail: 'No detail available for this tool call.',
      outputNotCaptured:
        'Output not captured (tool completed before result was received)',
      output: 'Output',
      input: 'Input',
      title: 'Tool call detail',
    },
    toggles: {
      web: 'Web',
      ask: 'Ask',
    },
    skillSelect: {
      ariaLabel: 'Select skill',
      downloadSkillTitle: 'Download skill definition',
      uploadSkillTitle: 'Upload skill definition',
      uploadFileInputAriaLabel: 'Upload skill markdown file',
    },
    toasts: {
      skillNotFound: 'Skill "{{skill}}" not found',
      couldNotReadFile: 'Could not read the file. Please try again.',
      cannotOverwriteBuiltin:
        'Cannot overwrite built-in skill "{{name}}". Rename your file (e.g. eva-{{name}}-custom.md).',
      uploadFailed: 'Upload failed for "{{name}}".',
      replacedSkill: 'Replaced existing custom skill "{{name}}".',
      uploadedSkill: 'Uploaded skill "{{name}}".',
      oauthRequired: 'OAuth token required',
      workflowSaved: 'Workflow saved',
    },
    settings: {
      previousSessions: 'Previous sessions',
      tokenNotSet: 'Not set',
      tokenSet: 'Set',
      tokenLabel: 'Token',
      buttonLabel: 'Settings and session history',
      buttonLabelTokenError: 'Settings — token error, click to fix',
      tokenPlaceholder: 'Paste OAuth token...',
    },
    sessions: 'sessions',
    sessionHistory: {
      fallbackChatName: 'Chat',
      emptyText: 'No previous sessions',
      messageCount: '{{n}}msg',
    },
    tabBar: {
      newTabAriaLabel: 'Open new chat tab',
      closeTabAriaLabel: 'Close {{label}} tab',
    },
    thinkingGroup: {
      expandAriaLabel: 'Expand {{count}} tool steps',
      collapseAriaLabel: 'Collapse tool steps',
      stepCount: '({{count}}x)',
    },
    status: {
      inference: 'Generating…',
      error: 'Error occurred',
      ask: 'Waiting for your answer',
      unread: 'Unread messages',
      idle: 'Idle, no activity',
    },
    panel: {
      messagePlaceholder: 'Ask me about LINQ...',
      messageAriaLabel: 'Message agent',
      stopAriaLabel: 'Stop agent response',
      sendAriaLabel: 'Send message',
      resizeAriaLabel: 'Resize input',
      emptyStateText: 'Ask me about LINQ',
      thinkingText: 'Thinking...',
      jumpToLatest: 'Jump to latest',
    },
    suggestedPrompts: {
      buildWorkflow: 'Build me a workflow',
      whatActionsAvailable: 'What actions are available?',
      explainWorkflow: 'Explain my workflow',
    },
    dialog: {
      openAriaLabel: 'Open Eva build agent',
      closeAriaLabel: 'Close build agent',
      ariaLabel: 'Eva build agent',
      resizeAriaLabel: 'Resize build agent panel',
    },
  },
  notebook: {
    title: 'Notebook analysis',
    runPicker: {
      title: 'Analyse executions in a notebook',
      description:
        'Choose the executions to pull into the notebook — the execution you came from is already selected.',
      descriptionNoPreselect:
        'Choose the executions to pull into the notebook.',
      legend: 'Executions to include in the analysis',
      next: 'Next',
      back: 'Back',
      open: 'Open notebook',
      selected: '{{count}} selected',
      presetFilterLabel: 'Execution preset',
      allWorkflows: 'All workflows',
      allPresets: 'All presets',
      dateRangeLabel: 'Date range',
      columnRun: 'Execution',
      columnPreset: 'Preset',
      columnStarted: 'Started',
      removeSelected: 'Remove {{label}}',
      notebookStepTitle: 'New analysis',
      notebookStepDescription:
        'Choose a notebook to start the analysis in, or continue with a blank one.',
      notebookLabel: 'Notebook',
    },
    spawning: 'Spinning up your notebook session…',
    sessionUnavailable: 'This notebook session is no longer available.',
    back: 'Go back',
    sessionError: 'Could not start the notebook session',
    connecting: 'Connecting to the kernel…',
    connectionError: 'Could not connect to the notebook kernel. {{error}}',
    runData: 'Execution data',
    dataError: 'Could not load the execution data.',
    runCell: 'Run cell',
    deleteCell: 'Delete cell',
    editMarkdown: 'Edit markdown',
    markdownPlaceholder: 'Empty markdown cell — double-click to edit',
    runAll: 'Run all',
    interrupt: 'Interrupt',
    restart: 'Restart',
    addCode: 'Code cell',
    addMarkdown: 'Markdown cell',
    saving: 'Saving…',
    saved: 'Saved',
    kernel: 'Kernel: {{status}}',
    imageOutput: 'Cell output',
    interactiveOutput: 'Interactive output',
    imageUnavailable: 'Image unavailable',
    openLens: 'Open notebook',
    openSession: 'Open editable notebook',
    openWorkflow: 'Open workflow',
    frameShape: '{{rows}} rows × {{cols}} columns',
    indexColumn: 'Index',
    endAnalysis: 'End analysis',
    openInJupyterLab: 'Open in JupyterLab',
    openInEva: 'Open in Eva',
    endAnalysisTitle: 'End analysis?',
    endAnalysisBody:
      "This removes the execution's notebook data. Save anything you want to keep to the library first.",
    endAnalysisError: 'Could not end the analysis',
  },
  notebookLibrary: {
    saved: 'Notebook saved',
    saveError: 'Could not save the notebook',
    rename: 'Rename',
    renameTitle: 'Rename notebook',
    deleteTitle: 'Delete notebook?',
    deleteBody: 'This removes {{name}} from the library and cannot be undone.',
    saveToLibrary: 'Save to library',
    saveToLibraryTitle: 'Save notebook to library',
    saveToLibrarySuccess: 'Notebook saved to the library',
    selectPackage: 'Select a package',
  },
  // NOTE: this group covers the Lens list + wizard (Task 10), the run picker
  // (Task 11), and the "Save as analysis" dialog + basic detail metadata
  // (Task 12). Task 13 (the read-only notebook viewer) adds its own keys here
  // when that code lands.
  lens: {
    // No separate "title" key: the page heading reuses common.lens (the
    // nav-dropdown label) rather than duplicating the "Lens" product name.
    analyse: 'Analyse',
    searchPlaceholder: 'Search analyses',
    agentSessions: {
      title: 'Agent sessions [{{count}}]',
      agent: 'Agent',
      messages: 'Messages',
      lastActive: 'Last active',
      view: 'View',
      untitled: 'Untitled session',
      readOnly: 'Read-only view of the agent session.',
      viewError: 'Could not load this session.',
      noMessages: 'No messages in this session.',
      toolActivity: 'Tool activity',
    },
    agentNotebooks: {
      title: 'Agent [{{count}}]',
    },
    source: 'from {{source}}',
    agentBadge: 'LINQ AI',
    agentBadgeLabel: 'Created by LINQ AI',
    cardMeta_one: '{{time}} · {{count}} execution',
    cardMeta_other: '{{time}} · {{count}} executions',
    analyseWithEva: 'Analyse with EVA',
    analyseDirectly: 'Analyse directly',
    empty: 'No analyses yet',
    emptyHint:
      'Start an analysis to save a read-only view of your execution data.',
    emptyFiltered: 'No analyses match these filters',
    emptyFilteredHint: 'Try adjusting or clearing the filters above.',
    creator: 'Creator',
    runsInAnalysis: 'Executions in this analysis',
    executionsInSession: 'Executions in this session',
    created: 'Created',
    detailsLabel: 'Analysis details',
    notebookLabel: 'Notebook',
    selectNotebook: 'Select a notebook',
    blankNotebook: 'Blank notebook',
    saveTitle: 'Save notebook as analysis',
    saveDescription:
      'Creates a durable, read-only copy of this notebook and its results.',
    saveAction: 'Save as analysis',
    saveSuccess: 'Analysis saved',
    saveError: 'Could not save the analysis',
    nameLabel: 'Analysis name',
    notFound: 'Analysis not found',
    readOnlyNotice: 'This analysis is a read-only snapshot.',
    executionsHeading: 'Executions',
    activeSessions: 'Active [{{count}}]',
    saved: 'Saved [{{count}}]',
    started: 'Started {{time}}',
    sessionMeta_one: 'Started {{time}} · {{count}} execution',
    sessionMeta_other: 'Started {{time}} · {{count}} executions',
    fork: 'Fork',
    forkTitle: 'Fork this analysis into a new editable session',
    forking: 'Forking…',
    forkError: 'Could not fork the analysis',
    openInEva: 'Open in Eva',
  },
} as const

type DeepStringValues<T> = {
  [K in keyof T]: T[K] extends string ? string : DeepStringValues<T[K]>
}

export type Ns1Translations = DeepStringValues<typeof ns1>
